/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle2, _circle3, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle4, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle5, _circle6, _circle7, _circle8, _path97, _circle9, _path98, _path99, _circle0, _path100, _circle1, _path101, _path102, _path103, _path104, _path105, _circle10, _circle11, _path106, _path107, _circle12, _path108, _path109, _circle13, _path110, _circle14, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _circle15, _circle16, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _circle17, _path167, _path168, _path169, _path170, _path171, _path172, _circle18, _circle19, _circle20, _circle21, _circle22, _path173, _path174, _path175, _path176, _circle23, _circle24, _circle25, _circle26, _path177, _path178, _path179, _path180, _path181, _circle27, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _circle28, _circle29, _path190, _path191, _path192, _path193, _path194, _path195, _circle30, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _circle31, _circle32, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _circle33, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _circle34, _path255, _circle35, _path256, _circle36, _path257, _circle37, _path258, _path259, _circle38, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _circle39, _path274, _path275, _circle40, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _circle41, _circle42, _path320, _path321, _circle43, _path322, _path323, _circle44, _circle45, _circle46, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _circle47, _path376, _path377;
const Humidity = /*#__PURE__*/React.forwardRef(function Humidity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Humidity.propTypes = iconPropTypes;
}
const HumidityAlt = /*#__PURE__*/React.forwardRef(function HumidityAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L25.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L29.3154,6.11A3.9693,3.9693,0,0,1,30,8.223,3.8978,3.8978,0,0,1,26,12Zm0-7.2368L24.3438,7.2257A1.89,1.89,0,0,0,24,8.223a2.0139,2.0139,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,30H8.5A6.4962,6.4962,0,0,1,7.2,17.1381a8.9938,8.9938,0,0,1,17.6006,0A6.4964,6.4964,0,0,1,23.5,30ZM16,12a7,7,0,0,0-6.9414,6.1452l-.0991.8122-.8155.064A4.4962,4.4962,0,0,0,8.5,28h15a4.4962,4.4962,0,0,0,.3564-8.9786l-.8154-.064-.0986-.8122A7.0022,7.0022,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HumidityAlt.propTypes = iconPropTypes;
}
const Hurricane = /*#__PURE__*/React.forwardRef(function Hurricane({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hurricane.propTypes = iconPropTypes;
}
const HybridNetworking = /*#__PURE__*/React.forwardRef(function HybridNetworking({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworking.propTypes = iconPropTypes;
}
const HybridNetworkingAlt = /*#__PURE__*/React.forwardRef(function HybridNetworkingAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworkingAlt.propTypes = iconPropTypes;
}
const IbmAiOnZ = /*#__PURE__*/React.forwardRef(function IbmAiOnZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m28,26c-.7384,0-1.3762.4047-1.7226,1h-5.2774l7.7998-10.4004c.2275-.3027.2642-.708.0947-1.0469s-.5156-.5527-.8945-.5527h-10.1843c-.4141-1.1615-1.5138-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.3019,0,2.4016-.8385,2.8157-2h8.1843l-7.7998,10.4004c-.2275.3027-.2642.708-.0947,1.0469s.5156.5527.8945.5527h7.2774c.3464.5953.9842,1,1.7226,1,1.1046,0,2-.8954,2-2s-.8954-2-2-2Zm-13-9c-.5513,0-1-.4482-1-1s.4487-1,1-1,1,.4482,1,1-.4487,1-1,1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m16,21h-2v4.5859L4.4139,16,14,6.4142v4.5858h2v-6h10v8h2V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h12v-8ZM4,5h8.5858L4,13.5858V5Zm0,22v-8.5858l8.5858,8.5858H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiOnZ.propTypes = iconPropTypes;
}
const IbmAiopsInsights = /*#__PURE__*/React.forwardRef(function IbmAiopsInsights({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23L2 30 9 30 5.5 23z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m26,15v2c1.1025,0,2,.8975,2,2v5c0,1.1025-.8975,2-2,2H10v2h16c2.2061,0,4-1.7939,4-4v-5c0-2.2056-1.7939-4-4-4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m14,24c-.4463,0-.8389-.2959-.9614-.7251l-1.793-6.2749h-3.2456v-2h4c.4463,0,.8389.2959.9614.7251l1.0386,3.6348,3.0386-10.6348c.1226-.4292.5151-.7251.9614-.7251s.8389.2959.9614.7251l1.793,6.2749h3.2456v2h-4c-.4463,0-.8389-.2959-.9614-.7251l-1.0386-3.6348-3.0386,10.6348c-.1226.4292-.5151.7251-.9614.7251Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m4,13v-5c0-1.103.897-2,2-2h16v-2H6c-2.2056,0-4,1.7944-4,4v5c0,2.2056,1.7944,4,4,4v-2c-1.103,0-2-.897-2-2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "5",
    r: "3"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiopsInsights.propTypes = iconPropTypes;
}
const IbmApiConnect = /*#__PURE__*/React.forwardRef(function IbmApiConnect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12c-1.1393,0-2.1624.484-2.8915,1.2505l-3.1586-1.7552c.0272-.162.05-.3257.05-.4954,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,1.0923.5928,2.0405,1.4676,2.5651l-.8963,4.4782c-1.4501.2102-2.5713,1.4492-2.5713,2.9567,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.0867-.0183-.1684-.0256-.2533l4.9317-2.2424c.7339.9048,1.8404,1.4957,3.0939,1.4957,2.2061,0,4-1.7939,4-4s-1.7939-4-4-4ZM12.9989,10.0002c.552,0,1.0004.4482,1.0004,1s-.4484,1-1.0004,1-1.0004-.4482-1.0004-1,.4484-1,1.0004-1ZM10.9982,22.0001c-.552,0-1.0004-.4482-1.0004-1s.4484-1,1.0004-1c.4135,0,.7687.2517.9209.6099l.0009.002c.0504.1194.0785.2505.0785.3881,0,.5518-.4484,1-1.0004,1ZM13.1545,18.9224c-.1838-.1906-.395-.3505-.6233-.4874l.8966-4.4782c.5893-.0854,1.1195-.3394,1.5463-.7159l3.1684,1.7599c-.0835.3213-.1418.6522-.1418.9993,0,.2355.0303.4633.0695.6877l-4.9158,2.2345ZM22.0022,18.0002c-1.1029,0-2.0007-.8975-2.0007-2s.8978-2,2.0007-2,2.0007.8975,2.0007,2-.8978,2-2.0007,2ZM27.0908,11.4079c.6175,1.4903.9125,3.0496.9092,4.5921-.0033,1.5629-.3128,3.1085-.9009,4.5475l1.7934.8965c.7238-1.7181,1.1039-3.5704,1.1075-5.444.0035-1.7996-.3405-3.6188-1.061-5.3572-2.2286-5.3799-7.4473-8.6357-12.939-8.6428-1.7888-.0023-3.6066.3401-5.3595,1.0661l.7655,1.8474c1.5025-.6221,3.0607-.9156,4.594-.9135,4.7072.0063,9.1801,2.7969,11.0908,7.4079ZM20.594,27.0868c-1.5026.6222-3.0607.9152-4.594.9132-4.7075-.0062-9.1802-2.797-11.0908-7.4076-.6175-1.4904-.9125-3.0498-.9092-4.5924.0033-1.5627.3128-3.1082.9009-4.5472l-1.7934-.8965c-.7237,1.718-1.1039,3.5702-1.1075,5.4437-.0035,1.7997.3404,3.619,1.061,5.3576,1.4775,3.5657,4.2683,6.1985,7.582,7.5705,1.6852.6977,3.5055,1.0695,5.357,1.0719,1.7887.0024,3.6064-.3399,5.3594-1.0658l-.7654-1.8474ZM25,23c-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2-.88-2-2-2ZM7,5c-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2-.88-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmApiConnect.propTypes = iconPropTypes;
}
const IbmAppConnectEnterprise = /*#__PURE__*/React.forwardRef(function IbmAppConnectEnterprise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19c-.2045,0-.404.0212-.597.0604l-2.5553-4.2578c.711-.7224,1.1523-1.7111,1.1523-2.8026,0-2.2061-1.7939-4-4-4s-4,1.7939-4,4c0,1.0931.4424,2.0834,1.1552,2.806l-3.111,5.1983c-.0151-.0003-.0291-.0043-.0443-.0043-1.12,0-2,.88-2,2s.88,2,2,2,2-.88,2-2c0-.3502-.0941-.6718-.2466-.9555l3.1263-5.2239c.3578.1053.7288.1794,1.1203.1794.3933,0,.7659-.0747,1.1251-.1809l2.5706,4.2833c-.428.5187-.6957,1.1741-.6957,1.8976,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3ZM14,12c0-1.1025.8975-2,2-2s2,.8975,2,2-.8975,2-2,2-2-.8975-2-2ZM22,23c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1ZM30,16.9995v-.0005h0c-.0005-7.7192-6.2805-13.999-14-13.999S2,9.2803,2,17c0,4.1558,2.0088,7.644,3.3611,8.8938,1.0293.9512,2.5835,2.1062,4.6389,2.1062,3.3086,0,6-2.6917,6-6,0-.834-.168-1.6416-.5-2.4006l-1.832.8008c.2197.5049.332,1.0432.332,1.5999,0,2.2056-1.7939,4-4,4s-4-1.7944-4-4,1.7939-4,4-4v-2c-2.5745,0-4.7689,1.6328-5.6187,3.9148-.2546-.9341-.3813-1.9031-.3813-2.9148,0-6.6167,5.3828-12,12-12s12,5.3833,12,12h.001c0,1.0518-.1367,2.0977-.4053,3.1084l1.9316.5156c.3145-1.1804.4734-2.3997.4727-3.624h0v-.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAppConnectEnterprise.propTypes = iconPropTypes;
}
const IbmApplicationAndDiscoveryDeliveryIntelligence = /*#__PURE__*/React.forwardRef(function IbmApplicationAndDiscoveryDeliveryIntelligence({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9,6h-2v10h2V6ZM28.5039,8.1362L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362l-4,2.3333c-.3071.1792-.4961.5081-.4961.8638v8.6667h2V4.9076l3-1.7499,11,6.4166v3.4257h2v-4c0-.3557-.189-.6846-.4961-.8638ZM4.9987,22.4315v-13.4315h-1.9987v14.006c0,.3559.1889.6849.4958.8642l10.4971,6.1298,1.0072-1.7282h-.0001s-10.0013-5.8403-10.0013-5.8403ZM22,26.9999h2v-9.9999h-2v9.9999ZM27,27h2v-6h-2v6ZM17,27h2v-8h-2v8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmApplicationAndDiscoveryDeliveryIntelligence.propTypes = iconPropTypes;
}
const IbmAspera = /*#__PURE__*/React.forwardRef(function IbmAspera({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11c-.75,0-1.39.4-1.73,1h-10.27c-2.21,0-4,1.79-4,4,0,.73.21,1.41.56,2h-6.83c-.34-.6-.98-1-1.73-1-1.12,0-2,.88-2,2s.88,2,2,2c.75,0,1.39-.4,1.73-1h10.27c2.21,0,4-1.79,4-4,0-.73-.21-1.41-.56-2h6.83c.34.6.98,1,1.73,1,1.12,0,2-.88,2-2s-.88-2-2-2ZM18,16c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM5.05,15h-2c0-7.29,5.08-12,12.95-12h10v2h-10c-6.75,0-10.95,3.83-10.95,10ZM16.05,29H6.05v-2h10c6.14,0,10.95-4.39,10.95-10h2c0,6.73-5.69,12-12.95,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAspera.propTypes = iconPropTypes;
}
const IbmBluepay = /*#__PURE__*/React.forwardRef(function IbmBluepay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5,26V15.8281l-3.5859,3.586L0,18l6-6,6,6-1.4141,1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31,18h-3v-2h-2v2h-1c-1.1046,0-2,.8954-2,2v2c0,1.1046,.8954,2,2,2h4v2h-6s0,2,0,2h3v2h2v-2h1c1.1046,0,2-.8954,2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H7V8H2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H10V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmBluepay.propTypes = iconPropTypes;
}
const IbmCloudant = /*#__PURE__*/React.forwardRef(function IbmCloudant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m16,26h5c3.86,0,7-3.14,7-7v-2h-2v2c0,2.76-2.24,5-5,5h-5v2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m20.25,14c-2.34,0-4.25-1.91-4.25-4.25,0-1.79,1.14-3.38,2.78-3.99.74-2.21,2.84-3.76,5.22-3.76s4.48,1.55,5.22,3.76c1.65.61,2.78,2.19,2.78,3.99,0,2.29-1.86,4.19-4.14,4.25h-7.61Zm3.75-10c-1.64,0-3.08,1.17-3.42,2.77l-.14.64-.64.13c-1.04.21-1.8,1.14-1.8,2.2,0,1.24,1.01,2.26,2.25,2.26h7.58c1.18-.03,2.17-1.05,2.17-2.26,0-1.06-.76-1.99-1.8-2.2l-.64-.13-.14-.64c-.34-1.6-1.78-2.77-3.42-2.77Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m4,14h2v-2c0-2.76,2.24-5,5-5h4v-2h-4c-3.86,0-7,3.14-7,7v2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m10,17h-6c-1.1,0-2,.9-2,2v10c0,1.1.9,2,2,2h6c1.1,0,2-.9,2-2v-10c0-1.1-.9-2-2-2Zm0,2v2h-6v-2h6Zm0,4v2h-6v-2h6Zm-6,6v-2h6v2H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudant.propTypes = iconPropTypes;
}
const IbmContentServices = /*#__PURE__*/React.forwardRef(function IbmContentServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmContentServices.propTypes = iconPropTypes;
}
const IbmDataPower = /*#__PURE__*/React.forwardRef(function IbmDataPower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21c-2.7568,0-5-2.2432-5-5s2.2432-5,5-5,5,2.2432,5,5-2.2432,5-5,5ZM16,13c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3ZM27,25c0-1.1046-.8954-2-2-2s-2,.8954-2,2,.8954,2,2,2,2-.8954,2-2ZM5,7c0,1.1046.8954,2,2,2s2-.8954,2-2-.8954-2-2-2-2,.8954-2,2ZM30,16c0-7.7197-6.2803-14-14-14-1.8638,0-3.6758.3623-5.3857,1.0771l.7715,1.8457c1.4644-.6123,3.0166-.9229,4.6143-.9229,6.2803,0,11.4492,4.8496,11.959,11h-4.959v2h7v-1ZM21.3857,28.9229l-.7715-1.8457c-1.4639.6123-3.0166.9229-4.6143.9229-6.2798,0-11.4487-4.8496-11.9585-11h4.9585v-2H2v1c0,7.7197,6.2803,14,14,14,1.8643,0,3.6768-.3623,5.3857-1.0771Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataPower.propTypes = iconPropTypes;
}
const IbmDataProductExchange = /*#__PURE__*/React.forwardRef(function IbmDataProductExchange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m24,21v2h1.7483c-2.2363,3.1196-5.8357,5-9.7483,5-6.6169,0-12-5.3833-12-12h-2c0,7.7197,6.2803,14,14,14,4.355,0,8.3743-2.001,11-5.3452v1.3452h2v-5h-5Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5046,11.6367l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-4.355,0-8.3743,2.001-11,5.3452v-1.3452h-2v5h5v-2h-1.7483c2.2363-3.1196,5.8357-5,9.7483-5,6.6169,0,12,5.3833,12,12h2c0-7.7197-6.2803-14-14-14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataProductExchange.propTypes = iconPropTypes;
}
const IbmDataReplication = /*#__PURE__*/React.forwardRef(function IbmDataReplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20v2h5.22a11.0163,11.0163,0,0,1-11.97,4.6533l-.4986,1.937A13,13,0,0,0,26,24.293V28h2V20Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25,3a4.0045,4.0045,0,0,0-4,4,3.954,3.954,0,0,0,.5669,2.019L9.019,21.5669A3.9521,3.9521,0,0,0,7,21a4,4,0,1,0,4,4,3.954,3.954,0,0,0-.5669-2.019L22.981,10.4331A3.9518,3.9518,0,0,0,25,11a4,4,0,0,0,0-8ZM7,27a2,2,0,1,1,2-2A2.002,2.002,0,0,1,7,27ZM25,9a2,2,0,1,1,2-2A2.002,2.002,0,0,1,25,9Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3A13.04,13.04,0,0,0,6,7.707V4H4v8h8V10H6.78a11.0163,11.0163,0,0,1,11.97-4.6533l.4986-1.937A13.0358,13.0358,0,0,0,16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataReplication.propTypes = iconPropTypes;
}
const IbmDataband = /*#__PURE__*/React.forwardRef(function IbmDataband({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.69,16.37c.84.83,1.31,1.97,1.31,3.15,0,1.19-.47,2.33-1.32,3.17-.88.87-2.03,1.31-3.18,1.31s-2.31-.44-3.19-1.31c-.59-.59-7.76-7.72-10.76-10.7l-1.27-1.27c-.59-.61-1.46-.84-2.28-.66-.47.11-.91.31-1.26.66-.47.47-.73,1.1-.73,1.76s.26,1.29.73,1.76c.52.51,6.74,6.7,6.74,6.7l-1.42,1.41-6.74-6.7c-.85-.85-1.32-1.97-1.32-3.17s.47-2.32,1.32-3.17c.85-.85,1.98-1.31,3.18-1.31s2.33.47,3.18,1.31l1.27,1.27,10.76,10.7c.98.97,2.56.97,3.54,0,.47-.47.73-1.1.73-1.76s-.26-1.29-.73-1.76l-6.73-6.69,1.42-1.41,6.74,6.7h0l.01.01ZM16,2c2.21,0,4,1.79,4,4s-1.79,4-4,4h0c-2.21,0-4-1.79-4-4s1.79-4,4-4h0ZM16.02,8c1.09,0,1.98-.9,1.98-2s-.89-2-1.98-2h-.09c-1.1.03-1.96.95-1.93,2.04h0c.02,1.1.92,1.97,2.02,1.95h0v.01ZM20,26c0,2.21-1.79,4-4,4s-4-1.79-4-4,1.79-4,4-4,4,1.79,4,4ZM16.02,28c1.09,0,1.98-.9,1.98-2s-.89-2-1.98-2h-.09c-1.1.03-1.96.95-1.93,2.04h0c.02,1.1.92,1.97,2.02,1.95h0v.01Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataband.propTypes = iconPropTypes;
}
const IbmDatastage = /*#__PURE__*/React.forwardRef(function IbmDatastage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.1V13h-2v9.1c-1.4,0.4-2.5,1.5-2.9,2.9H13v2h9.1c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4C30,24.1,28.7,22.6,27,22.1z M26,28c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S27.1,28,26,28z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2v-8h8V30z M4,28h4v-4H4V28z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9,7H19V5H9.9C9.4,3.3,7.9,2,6,2C3.8,2,2,3.8,2,6c0,1.9,1.3,3.4,3,3.9V19h2V9.9C8.4,9.5,9.5,8.4,9.9,7z M6,8 C4.9,8,4,7.1,4,6s0.9-2,2-2s2,0.9,2,2S7.1,8,6,8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDatastage.propTypes = iconPropTypes;
}
const IbmDb2 = /*#__PURE__*/React.forwardRef(function IbmDb2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m16,13c-3.4207,0-6,1.5049-6,3.5v8c0,1.9951,2.5793,3.5,6,3.5s6-1.5049,6-3.5v-8c0-1.9951-2.5793-3.5-6-3.5Zm0,2c2.4814,0,4,.9712,4,1.5s-1.5186,1.5-4,1.5-4-.9712-4-1.5,1.5186-1.5,4-1.5Zm0,11c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Zm0-4c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m30,15.5c0,3.08-2.14,5.65-5.0099,6.3199v-2.0699c1.75-.62,3.0099-2.28,3.0099-4.25,0-2.33-1.83-4.29-4.15-4.4801l-.81-.0599-.1-.8099c-.43-3.5-3.42-6.15-6.94-6.15-3.53,0-6.52,2.65-6.95,6.15l-.1.8099-.81.0599c-2.32.1901-4.14,2.1501-4.14,4.4801,0,1.96,1.25,3.62,2.9901,4.24v2.08c-2.86-.6799-4.9901-3.25-4.9901-6.3199,0-3.1,2.22-5.75,5.2-6.36.86-4.1201,4.52-7.14,8.8-7.14,4.27,0,7.9301,3.0199,8.8,7.14,2.97.61,5.2,3.26,5.2,6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2.propTypes = iconPropTypes;
}
const IbmDb2Alt = /*#__PURE__*/React.forwardRef(function IbmDb2Alt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3579,22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389,1.7849-1.8019,1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218,0-1.6658,.7649-1.9038,1.6658l-2.2268-.8499c.5271-1.6488,1.9038-3.0256,4.3687-3.0256,2.5667,0,4.0457,1.5128,4.0457,3.5696,0,2.0398-1.4619,3.2806-3.1619,4.6235l-2.2097,1.7339h5.6094v2.1417Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8291,9.4212h2.5159v5.1505h.085c.2549-.986,1.2407-1.6998,2.3967-1.6998,2.2607,0,3.4336,1.6318,3.4336,4.6575s-1.1729,4.6746-3.4336,4.6746c-1.156,0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212Zm5.8135,8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487,.4929-1.6487,1.3088v2.6348c0,.8159,.6968,1.3088,1.6487,1.3088s1.6489-.731,1.6489-1.8528Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1163,10.1351H5.5867c3.1448,0,5.2185,1.9889,5.2185,5.9325s-2.0737,5.9324-5.2185,5.9324H1.1163V10.1351Zm4.4704,9.5687c1.53,0,2.4819-.8329,2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Alt.propTypes = iconPropTypes;
}
const IbmDb2Warehouse = /*#__PURE__*/React.forwardRef(function IbmDb2Warehouse({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5039,17.6362l-6-3.5c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362l-6,3.5c-.3071.1792-.4961.5083-.4961.8638v7c0,.3555.189.6846.4961.8638l6,3.5c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l6-3.5c.3071-.1792.4961-.5083.4961-.8638v-7c0-.3555-.189-.6846-.4961-.8638Zm-1.5039,6.1978l-2.5317-1.519c.0132-.1045.0317-.207.0317-.3149,0-1.0225-.6187-1.9014-1.5-2.2881v-2.9707l4,2.333v4.7598Zm-6-7.0928v2.9707c-.8813.3867-1.5,1.2656-1.5,2.2881,0,.1079.0186.2104.0317.3149l-2.5317,1.519v-4.7598l4-2.333Zm1,11.1011l-3.9517-2.3052,2.5071-1.5039c.4087.291.9055.4668,1.4446.4668s1.0359-.1758,1.4446-.4668l2.5071,1.5039-3.9517,2.3052Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m24.8,9.14c-.87-4.12-4.52-7.14-8.8-7.14s-7.93,3.02-8.8,7.14c-2.97.6-5.2,3.26-5.2,6.36,0,3.07,2.14,5.63,5,6.31v-2.11c-1.74-.62-3-2.24-3-4.2,0-2.33,1.82-4.31,4.14-4.49l.82-.06.1-.81c.43-3.5,3.41-6.14,6.94-6.14s6.51,2.64,6.94,6.14l.1.81.82.06c2.32.19,4.14,2.16,4.14,4.49,0,1.95-1.26,3.59-3,4.21v2.11c2.86-.68,5-3.26,5-6.32,0-3.11-2.23-5.76-5.2-6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Warehouse.propTypes = iconPropTypes;
}
const IbmDeployableArchitecture = /*#__PURE__*/React.forwardRef(function IbmDeployableArchitecture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29,18c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2ZM24,4c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2ZM24,28c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2ZM25,15h-4.11c1.3-1.27,2.11-3.04,2.11-5v-2h-2v2c0,2.76-2.24,5-5,5h-7v2h7c2.76,0,5,2.24,5,5v2h2v-2c0-1.96-.81-3.73-2.11-5h4.11v-2ZM11.63,20.29l-.04.02-1.31.77-1.28.76-5-2.96v-5.76l5-2.96,1.28.76,1.31.77.04.02,1.71,1.02,1.02-1.72-1.71-1.02-.04-.02-1.33-.78-1.77-1.05c-.16-.09-.33-.14-.51-.14s-.35.05-.51.14l-6,3.55c-.3.18-.49.51-.49.86v6.9c0,.35.19.68.49.86l6,3.55c.16.09.33.14.51.14s.35-.05.51-.14l1.77-1.05,1.33-.78.04-.02,1.71-1.02-1.02-1.72-1.71,1.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDeployableArchitecture.propTypes = iconPropTypes;
}
const IbmDynamicRouteServer = /*#__PURE__*/React.forwardRef(function IbmDynamicRouteServer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "5",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "27",
    r: "2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m7,13H1v6h6v-6Zm-2,4h-2v-2h2v2Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m17.4999,6.6774c-1.316-1.67-3.3437-2.6774-5.4999-2.6774-2.4907,0-4.8135,1.3403-6.063,3.499l-1.1655,2.0186,1.7324,1,1.165-2.0176c.8921-1.542,2.5518-2.5,4.3311-2.5s3.439.958,4.3311,2.4995c.0048.0082.011.0154.0158.0236l-1.9328,3.348c-1.1128,1.9282-3.188,3.1274-5.415,3.1289l.001,1-.001,1c2.2271.002,4.3022,1.2002,5.415,3.1289l1.9326,3.347c-.0049.0084-.0112.0156-.0161.024-.8916,1.542-2.5513,2.5-4.3306,2.5s-3.439-.958-4.3306-2.499l-1.165-2.0186-1.7324,1,1.1655,2.0195c1.249,2.1572,3.5718,3.498,6.0625,3.498,2.1555,0,4.1829-1.0075,5.5004-2.6772,1.3154,1.6699,3.3427,2.6772,5.4996,2.6772h2v-2h-2c-1.7387,0-3.3566-.918-4.2612-2.3972.9349-1.003,2.254-1.6018,3.6547-1.6018h2.6064v-2h-2.6064c-1.7564,0-3.4199.6761-4.6906,1.824l-1.5565-2.6961c-.7776-1.3467-1.9164-2.4129-3.2465-3.1289,1.3301-.716,2.4688-1.7822,3.2465-3.1289l1.5565-2.6962c1.2706,1.1483,2.9341,1.8246,4.6906,1.8246h2.6064v-2h-2.6064c-1.4005,0-2.7194-.5986-3.6552-1.6017.9044-1.4795,2.5226-2.3978,4.2616-2.3978h2v-2h-2c-2.157,0-4.1844,1.0074-5.5001,2.6774Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDynamicRouteServer.propTypes = iconPropTypes;
}
const IbmEloAutomotiveCompliance = /*#__PURE__*/React.forwardRef(function IbmEloAutomotiveCompliance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.9467,13.9356h-2c-.7368,0-1.3748.4051-1.7218,1H6.0151l2.625-7h7.3073v-2h-7.3073c-.8291,0-1.5811.521-1.873,1.2974l-2.5137,6.7026-2.3066-.0005v2l2,.0002v9.0002c0,1.103.8975,2,2,2v3h2v-3h16v3h2v-3c1.1025,0,2-.897,2-2v-9h2v-2ZM5.9467,24.9356v-3h3v-2h-3v-3h20v3h-3v2h3v3H5.9467Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11.979 19.941H19.979V21.941H11.979z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M29.5367 2.5256L22.9467 9.1154 20.3567 6.5255 18.9467 7.9356 22.9467 11.9356 30.9467 3.9356 29.5367 2.5256z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloAutomotiveCompliance.propTypes = iconPropTypes;
}
const IbmEloEngineeringInsights = /*#__PURE__*/React.forwardRef(function IbmEloEngineeringInsights({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,16c-.0925,0-.1792.021-.27.0273l-.8916-2.6743c.7017-.5493,1.1616-1.3945,1.1616-2.353,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,.3804.0784.7412.208,1.0762l-2.7224,2.333c-.4399-.2529-.9426-.4092-1.4856-.4092-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.9915,0,1.865-.4893,2.4116-1.2324l3.6038,1.0811c-.002.0513-.0154.0996-.0154.1514,0,2.2056,1.7944,4,4,4s4-1.7944,4-4-1.7944-4-4-4Zm-3-6c.5513,0,1,.4487,1,1s-.4487,1-1,1-1-.4487-1-1,.4487-1,1-1Zm-7,8c-.5513,0-1-.4487-1-1s.4487-1,1-1,1,.4487,1,1-.4487,1-1,1Zm2.9849-1.1484c-.0161-.3257-.0806-.6372-.1929-.9277l2.7224-2.333c.4243.2441.908.3936,1.4294.4033l.885,2.6553c-.5046.3281-.9229.7695-1.2363,1.2842l-3.6077-1.082Zm7.0151,5.1484c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.4961,9.8638l-11.4961-6.7061-8.4961,4.9561-1.0078-1.7275L15.4961,1.1362c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12,7-1.0078,1.7275Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16.5039,30.8638l-1.0078-1.7275,11.5039-6.7106v-10.4257h2v11c0,.3557-.189.6846-.4961.8638l-12,7Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12.4961,29.1138l-9-5.25c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l8.5039,4.9606-1.0078,1.7275Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloEngineeringInsights.propTypes = iconPropTypes;
}
const IbmEloMethodComposer = /*#__PURE__*/React.forwardRef(function IbmEloMethodComposer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13.76,10.463l-3.297,3.297c-.6173.6173-.6173,1.6227,0,2.24l12.0044,12h5.5326v-5.5326l-12-12.0044c-.6173-.6173-1.6226-.6173-2.2399,0h0Zm12.24,12.8328v2.7042h-2.7042l-7.4409-7.4409,2.7042-2.7042,7.4409,7.4409Zm-8.855-8.8549l-2.7041,2.7041-2.2672-2.2672,2.7042-2.7042,2.2671,2.2673Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2v8h-8v-2h4.92c-2.25-2.53-5.46-4-8.92-4-6.61,0-12,5.38-12,12,0,6.61,5.39,12,12,12h1v2h-1c-7.72,0-14-6.28-14-14S8.28,2,16,2c3.83,0,7.4,1.5499,10,4.23V2h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloMethodComposer.propTypes = iconPropTypes;
}
const IbmEloPublishing = /*#__PURE__*/React.forwardRef(function IbmEloPublishing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M18 26L26.1719 26 23.5859 28.5859 25 30 30 25 25 20 23.5859 21.4141 26.1719 24 18 24 18 26z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 21H15V23H10z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 16H20V18H10z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24.7,9.3l-7-7c-.2-.2-.4-.3-.7-.3H7c-1.1,0-2,.8999-2,2v24c0,1.103.8975,2,2,2h8v-2h-8V4h8v6c0,1.1001.9,2,2,2h6v6h2v-8c0-.3-.1-.5-.3-.7Zm-7.7.7v-5.6001l5.6,5.6001h-5.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEloPublishing.propTypes = iconPropTypes;
}
const IbmEngineeringLifecycleMgmt = /*#__PURE__*/React.forwardRef(function IbmEngineeringLifecycleMgmt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31,22v-2h-2.1006c-.1299-.6372-.3845-1.2285-.7322-1.7529l1.4895-1.4897-1.4141-1.4141-1.4897,1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141,1.4141,1.4893,1.4897c-.3477.5244-.6021,1.1157-.7319,1.7529h-2.1006v2h2.1006c.1299.6372.3843,1.2285.7319,1.7532l-1.4893,1.4895,1.4141,1.4141,1.4897-1.4897c.5244.3477,1.1157.6021,1.7529.7319v2.1011h2v-2.1011c.6372-.1299,1.2285-.3843,1.7529-.7319l1.4897,1.4897,1.4141-1.4141-1.4895-1.4895c.3479-.5247.6023-1.116.7322-1.7532h2.1006Zm-7,2c-1.6567,0-3-1.3433-3-3s1.3433-3,3-3c1.6567,0,3,1.3433,3,3s-1.3433,3-3,3Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,6c0-2.7568-2.2432-5-5-5-1.7798,0-3.439.9575-4.3306,2.4995-.3201.5535-.5259,1.146-.6289,1.7944-1.1428-.8115-2.5352-1.2939-4.0405-1.2939C3.1401,4,0,7.1401,0,11c0,2.6981,1.5368,5.0403,3.7787,6.2083-1.0787.918-1.7787,2.2679-1.7787,3.7917,0,2.7568,2.2432,5,5,5,.7344,0,1.4265-.1685,2.0552-.4539.2764,2.4973,2.375,4.4539,4.9448,4.4539,1.335,0,2.5908-.52,3.5356-1.4639l-1.4141-1.415c-.5669.5669-1.3203.8789-2.1216.8789-1.6543,0-3-1.3457-3-3s1.3457-3,3-3v-2c-.7344,0-1.4265.1685-2.0552.4539-.1435-1.2966-.7849-2.4395-1.7218-3.2463,2.241-1.1685,3.777-3.51,3.777-6.2075,0-.1472-.0139-.2911-.0229-.4363.6199.2761,1.3018.4363,2.0229.4363,2.7568,0,5-2.2432,5-5Zm-7.5991-1.4995c.5352-.9253,1.5312-1.5005,2.5991-1.5005,1.6543,0,3,1.3457,3,3s-1.3457,3-3,3-3-1.3457-3-3h-.0293c.0352-.5762.1714-1.0522.4302-1.4995Zm-3.4009,16.4995c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Zm-3-5c-2.7568,0-5-2.2432-5-5s2.2432-5,5-5,5,2.2432,5,5-2.2432,5-5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringLifecycleMgmt.propTypes = iconPropTypes;
}
const IbmEngineeringRequirementsDoorsNext = /*#__PURE__*/React.forwardRef(function IbmEngineeringRequirementsDoorsNext({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,4h-3v1.9991l3-.0005v20.0015h-3v2h3c1.103,0,2-.897,2-2V6c0-1.103-.897-2-2-2Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "17",
    r: "2",
    strokeWidth: "0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,4v24c0,1.103-.897,2-2,2H4c-1.103,0-2-.897-2-2V4c0-1.103.897-2,2-2h16c1.103,0,2,.897,2,2ZM4,28h16s0-24.0015,0-24.0015l-16,.0015v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringRequirementsDoorsNext.propTypes = iconPropTypes;
}
const IbmEngineeringSystemsDesignRhapsody = /*#__PURE__*/React.forwardRef(function IbmEngineeringSystemsDesignRhapsody({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,10h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v4c0,1.1046.8954,2,2,2Zm0-6h4v4h-4v-4Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,22h-4c-1.1046,0-2,.8954-2,2v4c0,1.1046.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2Zm0,6h-4v-4h4v4Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21.414,12.586l-1.414,1.414,6,6,6-6-1.414-1.414-3.586,3.586V7c0-1.1046-.8954-2-2-2h-13v2h13v9.172l-3.586-3.586Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m7,15.828l3.586,3.586,1.414-1.414-6-6L0,18l1.414,1.414,3.586-3.586v9.172c0,1.1046.8954,2,2,2h13v-2H7v-9.172Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringSystemsDesignRhapsody.propTypes = iconPropTypes;
}
const IbmEngineeringSystemsDesignRhapsodyModelManager = /*#__PURE__*/React.forwardRef(function IbmEngineeringSystemsDesignRhapsodyModelManager({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,30h-8c-2.2061,0-4-1.7939-4-4,0-1.8887,1.3164-3.4766,3.0801-3.8936.4219-2.332,2.4678-4.1064,4.9199-4.1064s4.498,1.7744,4.9199,4.1064c1.7637.417,3.0801,2.0049,3.0801,3.8936,0,2.2061-1.7939,4-4,4Zm-8-2h8c1.1025,0,2-.8975,2-2s-.8975-2-2-2h-1v-1c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3v1h-1c-1.1025,0-2,.8975-2,2s.8975,2,2,2Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,27h-2c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h2v2Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,15v-4c0-3.8599-3.1401-7-7-7h-7v2h7c2.7568,0,5,2.2432,5,5v4h2Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m10,8V4c0-1.1046-.8954-2-2-2H2v13h2v-5h1.48l2.34,5h2.18l-2.33-5h.33c1.1046,0,2-.8954,2-2ZM4,4h4v4h-4V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringSystemsDesignRhapsodyModelManager.propTypes = iconPropTypes;
}
const IbmEngineeringSystemsDesignRhapsodySn1 = /*#__PURE__*/React.forwardRef(function IbmEngineeringSystemsDesignRhapsodySn1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,27h-3c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h3v2Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,27h-4c-1.1025,0-2-.8975-2-2v-4c0-1.1025.8975-2,2-2h4c1.1025,0,2,.8975,2,2v4c0,1.1025-.8975,2-2,2Zm-4-6h-.002l.002,4h4v-4h-4Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M25 15H27V17H25z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M29 19H31V21H29z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M29 23H31V25H29z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M15 21H17V23H15z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M15 25H17V27H15z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M15 29H17V31H15z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M19 29H21V31H19z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,13v-2c0-3.8599-3.1401-7-7-7h-7v2h7c2.7568,0,5,2.2432,5,5v2h2Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m10,8V4c0-1.1046-.8954-2-2-2H2v13h2v-5h1.48l2.34,5h2.18l-2.33-5h.33c1.1046,0,2-.8954,2-2ZM4,4h4v4h-4V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringSystemsDesignRhapsodySn1.propTypes = iconPropTypes;
}
const IbmEngineeringSystemsDesignRhapsodySn2 = /*#__PURE__*/React.forwardRef(function IbmEngineeringSystemsDesignRhapsodySn2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M19 24H21V26H19z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17,21h12c1.1046,0,2,.8954,2,2v4c0,1.1046-.8954,2-2,2h-12c-1.1046,0-2-.8954-2-2v-4c0-1.1046.8954-2,2-2Zm12,6v-4h-12v4h12Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,27h-2c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h2v2Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,18v-7c0-3.8599-3.1401-7-7-7h-7v2h7c2.7568,0,5,2.2432,5,5v7h2Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m10,8V4c0-1.1046-.8954-2-2-2H2v13h2v-5h1.48l2.34,5h2.18l-2.33-5h.33c1.1046,0,2-.8954,2-2ZM4,4h4v4h-4V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringSystemsDesignRhapsodySn2.propTypes = iconPropTypes;
}
const IbmEngineeringTestMgmt = /*#__PURE__*/React.forwardRef(function IbmEngineeringTestMgmt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c-7.7197,0-14-6.2803-14-14h2c0,6.6167,5.3833,12,12,12s12-5.3833,12-12h2c0,7.7197-6.2803,14-14,14Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,26c-5.5139,0-10-4.4861-10-10h2c0,4.4111,3.5889,8,8,8s8-3.5889,8-8h2c0,5.5139-4.4861,10-10,10Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,20c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Zm0-6c-1.103,0-2,.897-2,2s.897,2,2,2,2-.897,2-2-.897-2-2-2Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-4.9719,0-9.4933,2.6113-12,6.7883v-4.7883h-2v8h8v-2h-4.3881c2.126-3.6848,6.0558-6,10.3881-6,3.2051,0,6.2188,1.248,8.4854,3.5146l1.4141-1.4141c-2.644-2.6445-6.1597-4.1006-9.8994-4.1006Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringTestMgmt.propTypes = iconPropTypes;
}
const IbmEngineeringWorkflowMgmt = /*#__PURE__*/React.forwardRef(function IbmEngineeringWorkflowMgmt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31.3242,11.2612c-2.5444-2.103-5.7671-3.2612-9.0737-3.2612h-.2505v2h.2505c2.6079,0,5.1543.8374,7.2456,2.3716-1.3672,3.3955-4.1621,5.9414-7.5483,7.0366.0347-.4028.0522-.8096.0522-1.2197,0-7.8237-6.3647-14.1885-14.1885-14.1885-.9282,0-1.8555.0903-2.7563.2681l-.6572.1299-.1299.6572c-.1777.9009-.2681,1.8281-.2681,2.7563,0,4.1244,1.7795,7.8315,4.5983,10.4264-.3759,1.2767-.5992,2.6185-.5992,4.0165l.001.0009c.0011,3.3049,1.159,6.5258,3.261,9.069l.4385.5303.6523-.2202c4.6675-1.5752,8.0962-5.4111,9.2368-10.0454,4.6343-1.1406,8.4702-4.5693,10.0454-9.2368l.2202-.6523-.5303-.4385ZM12.3716,29.4961c-1.5342-2.0913-2.3716-4.6377-2.3716-7.2456h-.0006c.0003-.9115.1136-1.7958.304-2.6512,2.2567,1.5145,4.9689,2.4008,7.8851,2.4008.4102,0,.8169-.0176,1.2197-.0522-1.0952,3.3862-3.6411,6.1812-7.0366,7.5483Zm7.5112-9.6133c-.5557.0771-1.1211.1172-1.6943.1172-2.7159,0-5.2186-.9039-7.2472-2.4116.8616-2.0793,2.2642-3.881,4.0479-5.204l-1.28-1.53c-1.8557,1.3905-3.3427,3.2305-4.3404,5.3458-2.0815-2.1875-3.3687-5.1378-3.3687-8.3887,0-.5684.0391-1.1357.1167-1.6948.5591-.0776,1.1265-.1167,1.6948-.1167,6.7207,0,12.1885,5.4678,12.1885,12.1885,0,.5732-.04,1.1387-.1172,1.6943Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "2",
    r: "2",
    strokeWidth: "0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "26",
    r: "2",
    strokeWidth: "0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "2",
    strokeWidth: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEngineeringWorkflowMgmt.propTypes = iconPropTypes;
}
const IbmEventAutomation = /*#__PURE__*/React.forwardRef(function IbmEventAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5,30c-3.0586,0-5.9485-1.4867-7.7305-3.9771l1.6265-1.1638c1.4075,1.9667,3.6892,3.1409,6.104,3.1409,3.969,0,7.2578-3.1002,7.4873-7.0579l1.9966.1157c-.2908,5.0143-4.4565,8.9421-9.4839,8.9421Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "23",
    r: "2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6411,19.0948l-1.9243-.5449c.188-.6638.2832-1.3535.2832-2.0499,0-4.1355-3.3645-7.5-7.5-7.5-1.0769,0-2.1157.223-3.0876.6628l-.8247-1.822c1.2329-.558,2.5491-.8408,3.9124-.8408,5.2383,0,9.5,4.2617,9.5,9.5,0,.8807-.1208,1.7537-.3589,2.5948Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0254,19.8821c-3.0999-1.6578-5.0254-4.8696-5.0254-8.3821C3,6.4729,6.9277,2.307,11.9421,2.0161l.1157,1.9966c-3.9578.2297-7.0579,3.5186-7.0579,7.4873,0,2.7732,1.5208,5.3092,3.9688,6.6184l-.9434,1.7637Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventAutomation.propTypes = iconPropTypes;
}
const IbmEventEndpointMgmt = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m25,30h-8c-1.1028,0-2-.8972-2-2v-4h2v4h8v2Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m30,25h-2v-8h-5v-2h5c1.1028,0,2,.8972,2,2v8Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m9,17H4c-1.1028,0-2-.8972-2-2V7h2v8h5v2Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m17,8h-2V4H7v-2h8c1.1028,0,2,.8972,2,2v4Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventEndpointMgmt.propTypes = iconPropTypes;
}
const IbmEventProcessing = /*#__PURE__*/React.forwardRef(function IbmEventProcessing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5,30h-2.5v-2h2.5c3.0327,0,5.5-2.4673,5.5-5.5,0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026,5.77,3.8042,5.77,7.2993,0,4.1355-3.3645,7.5-7.5,7.5Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventProcessing.propTypes = iconPropTypes;
}
const IbmEventStreams = /*#__PURE__*/React.forwardRef(function IbmEventStreams({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventStreams.propTypes = iconPropTypes;
}
const IbmGcm = /*#__PURE__*/React.forwardRef(function IbmGcm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 17L17.1719 17 13.5859 20.5859 15 22 21 16 15 10 13.5859 11.4141 17.1719 15 2 15 2 17z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28.5039,8.1362L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5083-.4961.8638v3h2v-2.4258L16,3.1577l11,6.4165v12.8516l-11,6.4165-11.7275-6.8423-1.0078,1.7275,12.2314,7.1362c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l12-7c.3071-.1792.4961-.5083.4961-.8638v-14c0-.3555-.189-.6846-.4961-.8638Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmGcm.propTypes = iconPropTypes;
}
const IbmGlobalStorageArchitecture = /*#__PURE__*/React.forwardRef(function IbmGlobalStorageArchitecture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM5,26c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM27,26c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM6,24v-3h9v3h2v-3h9v3h2v-3c0-1.1-.9-2-2-2h-9v-3h-2v3H6c-1.1,0-2,.9-2,2v3h2ZM21.7,6.1c-.8-2.4-3.1-4.1-5.7-4.1s-4.9,1.7-5.7,4.1c-1.9.3-3.3,1.9-3.3,3.9s1.8,4,4,4h10c2.2,0,4-1.8,4-4s-1.4-3.6-3.3-3.9ZM21,12h-10c-1.1,0-2-.9-2-2s.9-2,2-2h1c0-2.2,1.8-4,4-4s4,1.8,4,4h1c1.1,0,2,.9,2,2s-.9,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmGlobalStorageArchitecture.propTypes = iconPropTypes;
}
const IbmGranite = /*#__PURE__*/React.forwardRef(function IbmGranite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5039,8.1362L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3482.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5083-.4961.8638v14c0,.3555.189.6846.4961.8643l12,7c.1558.0908.3296.1357.5039.1357s.3481-.0449.5039-.1357l12-7c.3076-.1797.4961-.5088.4961-.8643v-14c0-.3555-.1885-.6846-.4961-.8638ZM16,3.1577l10.0155,5.8422-2.3773,1.3867-5.6382-3.2529c-.3105-.1787-.6895-.1787-1,0l-6.4995,3.75c-.1992.115-.3417.2961-.4235.5034l-4.0925-2.3873,10.0155-5.8422h0ZM12,14.8244l3,1.75v3.8291l-3-1.7307v-3.8484ZM16,14.8423l-4-2.3333v-.1813l5.5-3.1733,4.148,2.3933-5.648,3.2947h0ZM17,16.5744l6-3.5v5.5984l-5.5,3.1729-.5-.2885v-4.9828ZM5,10.741l5,2.9167v5.5923c0,.3574.1909.6875.5005.8662l4.4995,2.5961v5.5471l-10-5.8336v-11.6848ZM17,28.2594v-4.3932c.1553.0889.3271.1338.5.1338s.3447-.0449.5-.1338l6.5-3.75c.3096-.1787.5-.5088.5-.8662v-7.3423l2-1.1667v11.6848l-10,5.8336Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmGranite.propTypes = iconPropTypes;
}
const IbmIbv = /*#__PURE__*/React.forwardRef(function IbmIbv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m15,24c-3.8594,0-7-3.1401-7-7s3.1406-7,7-7,7,3.1401,7,7-3.1406,7-7,7Zm0-12c-2.7568,0-5,2.2432-5,5s2.2432,5,5,5,5-2.2432,5-5-2.2432-5-5-5Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m30,13h-2V4h-9v-2h9c1.1025,0,2,.897,2,2v9Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30c-7.168,0-13-5.8315-13-13S7.832,4,15,4v2c-6.0654,0-11,4.9346-11,11s4.9346,11,11,11,11-4.9346,11-11v-1h2v1c0,7.1685-5.832,13-13,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmIbv.propTypes = iconPropTypes;
}
const IbmInstana = /*#__PURE__*/React.forwardRef(function IbmInstana({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H11V19H9z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H23V19H21z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H15V24H13z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H19V22H17z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "5",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "27",
    r: "2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m22.0916,28h-8.0916v-2h8.0916l5.9082-10-2.6992-4.5679,1.7227-1.0176,2.6992,4.5679c.3701.6274.3701,1.4077,0,2.0352l-5.9092,10c-.3574.6055-1.0176.9824-1.7217.9824Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m4.9768,21.5859l-2.6992-4.5684c-.3701-.6274-.3701-1.4077,0-2.0352l5.9092-10c.3584-.606,1.0176-.9824,1.7217-.9824h8.0916v2h-8.0916l-5.9082,10,2.6992,4.5684-1.7227,1.0176Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmInstana.propTypes = iconPropTypes;
}
const IbmJrs = /*#__PURE__*/React.forwardRef(function IbmJrs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 18L10 18 10 6 7 6 7 18 5 18 5 4 12 4 12 18z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M21 26L19 26 19 12 16 12 16 21.9946 14 21.9946 14 10 21 10 21 26z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 26L28 26 28 18 25 18 25 26 23 26 23 16 30 16 30 26z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20L4 22 8.5859 22 2 28.5859 3.4141 30 10 23.4141 10 28 12 28 12 20 4 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmJrs.propTypes = iconPropTypes;
}
const IbmKnowledgeCatalog = /*#__PURE__*/React.forwardRef(function IbmKnowledgeCatalog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M24,25h-3v-3h3v3ZM29,22h-3v3h3v-3ZM24,27h-3v3h3v-3ZM29,27h-3v3h3v-3ZM20,8h-8v2h8v-2ZM17,28H6v-4h2v-2h-2v-5h2v-2h-2v-5h2v-2h-2v-4h18v15h2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v4h-2v2h2v5h-2v2h2v5h-2v2h2v4c0,1.1.9,2,2,2h11v-2ZM20,15h-8v2h8v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmKnowledgeCatalog.propTypes = iconPropTypes;
}
const IbmKnowledgeCatalogPremium = /*#__PURE__*/React.forwardRef(function IbmKnowledgeCatalogPremium({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10h-8v-2h8v2ZM17,28H6v-4h2v-2h-2v-5h2v-2h-2v-5h2v-2h-2v-4h18v15h2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v4h-2v2h2v5h-2v2h2v5h-2v2h2v4c0,1.1.9,2,2,2h11v-2ZM20,15h-8v2h8v-2ZM23.4,24.3l-3.7.5,2.7,2.6-.7,3.6,3.4-1.7,3.2,1.7-.7-3.6,2.7-2.6-3.6-.5-1.7-3.3s-1.6,3.3-1.6,3.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmKnowledgeCatalogPremium.propTypes = iconPropTypes;
}
const IbmKnowledgeCatalogStandard = /*#__PURE__*/React.forwardRef(function IbmKnowledgeCatalogStandard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10h-8v-2h8v2ZM16,28H6v-4h2v-2h-2v-5h2v-2h-2v-5h2v-2h-2v-4h18v17h2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v4h-2v2h2v5h-2v2h2v5h-2v2h2v4c0,1.1.9,2,2,2h10v-2ZM20,15h-8v2h8v-2ZM23,27.2l-2.6-2.6-1.4,1.4,4,4,7-7-1.4-1.4-5.6,5.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmKnowledgeCatalogStandard.propTypes = iconPropTypes;
}
const IbmLaunchpadS4 = /*#__PURE__*/React.forwardRef(function IbmLaunchpadS4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,26v2H4V10h2v-2h-2c-1.1045,0-2,.8955-2,2v18c0,1.1045.8955,2,2,2h18c1.1045,0,2-.8955,2-2v-2h-2Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,5.9932v-1.9932c0-1.1046-.8954-2-2-2H10c-1.1046,0-2,.8954-2,2v18c0,1.1046.8954,2,2,2h18c1.1046,0,2-.8954,2-2v-3h-2v3H10V4h18v1.9932h2Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.5,17h-9c-1.9297,0-3.5-1.5703-3.5-3.5,0-1.7935,1.3555-3.2759,3.0957-3.4766.4561-2.291,2.4814-4.0234,4.9043-4.0234s4.4482,1.7324,4.9043,4.0234c1.7402.2007,3.0957,1.6831,3.0957,3.4766,0,1.9297-1.5703,3.5-3.5,3.5Zm-9-5c-.8271,0-1.5.6729-1.5,1.5s.6729,1.5,1.5,1.5h9c.8271,0,1.5-.6729,1.5-1.5s-.6729-1.5-1.5-1.5h-1.5v-1c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3v1h-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmLaunchpadS4.propTypes = iconPropTypes;
}
const IbmLpa = /*#__PURE__*/React.forwardRef(function IbmLpa({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,30h-2v-2c0-.5513-.4482-1-1-1h-6c-.5518,0-1,.4487-1,1v2h-2v-2c0-1.6543,1.3457-3,3-3h6c1.6543,0,3,1.3457,3,3v2Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,24c-2.2061,0-4-1.7944-4-4s1.7939-4,4-4,4,1.7944,4,4-1.7939,4-4,4Zm0-6c-1.1025,0-2,.897-2,2s.8975,2,2,2,2-.897,2-2-.8975-2-2-2Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 20H10V22H8z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 20H18V22H12z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 16H10V18H8z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 16H18V18H12z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 12H10V14H8z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 12H18V14H12z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,5h-3v-1c0-1.103-.8975-2-2-2h-6c-1.1025,0-2,.897-2,2v1h-3c-1.1025,0-2,.897-2,2v19c0,1.103.8975,2,2,2h9v-2H5V7h3v2h10v-2h3v6.9999h2v-6.9999c0-1.103-.8975-2-2-2Zm-5,2h-6v-3h6v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmLpa.propTypes = iconPropTypes;
}
const IbmLqe = /*#__PURE__*/React.forwardRef(function IbmLqe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31,29.5859l-8.5479-8.5469c-2.0986,2.5171-5.178,3.9609-8.4521,3.9609-6.0654,0-11-4.9346-11-11S7.9346,3,14,3s11,4.9346,11,11c0,1.6001-.3354,3.1416-.9968,4.583l1.8174.834c.7827-1.7041,1.1794-3.5269,1.1794-5.417,0-7.168-5.8318-13-13-13S1,6.832,1,14s5.8318,13,13,13c3.1343,0,6.1025-1.1387,8.4395-3.1465l7.1465,7.1465,1.4141-1.4141Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17,15c-.8066,0-1.5369.3237-2.0767.8438l-2.96-1.4805c.0146-.1201.0366-.2388.0366-.3633s-.022-.2432-.0366-.3633l2.96-1.4805c.5398.52,1.27.8438,2.0767.8438,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.1245.022.2432.0366.3633l-2.96,1.4805c-.5398-.52-1.27-.8438-2.0767-.8438-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.8066,0,1.5369-.3237,2.0767-.8438l2.96,1.4805c-.0146.1201-.0366.2388-.0366.3633,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3Zm0-6c.5515,0,1,.4482,1,1s-.4485,1-1,1-1-.4482-1-1,.4485-1,1-1Zm-8,6c-.5515,0-1-.4482-1-1s.4485-1,1-1,1,.4482,1,1-.4485,1-1,1Zm8,4c-.5515,0-1-.4482-1-1s.4485-1,1-1,1,.4482,1,1-.4485,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmLqe.propTypes = iconPropTypes;
}
const IbmMachineLearningForZos = /*#__PURE__*/React.forwardRef(function IbmMachineLearningForZos({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M17,27v-6h-2v4.6l-9.6-9.6L15,6.4v4.6h2v-6h10v8h2V5c0-1.1-.9-2-2-2H5c-1.1,0-2,.9-2,2v22c0,1.1.9,2,2,2h12v-2ZM5,5h8.6L5,13.6V5ZM5,27v-8.6l8.6,8.6H5ZM26.6,19l-3.7-3.7c-.2-.2-.4-.3-.6-.3h-3.5c-.6-1.6-2.3-2.4-3.8-1.8-.9.3-1.6,1-1.8,1.9-.5,1.6.4,3.3,2,3.7,1.5.5,3.1-.3,3.7-1.8h3l3.8,3.8c.1.1.3.2.5.2h3.9v-2s-3.5,0-3.5,0ZM16,17c-.6,0-1-.4-1-1s.4-1,1-1,1,.4,1,1-.4,1-1,1ZM24.8,23c-.4-1.2-1.5-2-2.8-2s-3,1.3-3,3,1.4,3,3,3,2.4-.8,2.8-2h5.2v-2h-5.2ZM22,25c-.5,0-1-.5-1-1s.5-1,1-1,1,.5,1,1-.4,1-1,1ZM26,27h4v2h-4v-2ZM28,15h2v2h-2v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMachineLearningForZos.propTypes = iconPropTypes;
}
const IbmMatch_360 = /*#__PURE__*/React.forwardRef(function IbmMatch_360({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M5,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,5,25Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,25Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M28,23H26V11a2.0059,2.0059,0,0,0-2-2H22V7h2a4.0118,4.0118,0,0,1,4,4Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V23H15z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M6,23H4V11A4.0118,4.0118,0,0,1,8,7h2V9H8a2.0059,2.0059,0,0,0-2,2Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2,14.7,4.6343l-2.9057.42,2.1029,2.0514L13.4,10,16,8.6343,18.6,10l-.4972-2.8943,2.1029-2.0486L17.3,4.6343Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMatch_360.propTypes = iconPropTypes;
}
const IbmMaximoApplicationSuite = /*#__PURE__*/React.forwardRef(function IbmMaximoApplicationSuite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M22,3v2h-12.4258l-6.4238,11.0117,3.6408,6.5537.7783-2.5654,1.9139.5806-1.7417,5.7416-5.7416-1.7416.5806-1.9139s1.2918.3851,2.375.712l-3.8296-6.8933c-.1719-.3086-.168-.6846.0098-.9893L8.1357,3.4961c.1797-.3076.5088-.4961.8643-.4961h13ZM23,29c.3555,0,.6846-.1885.8643-.4961l7-12c.1777-.3047.1816-.6807.0098-.9893l-3.8296-6.8933c1.0832.3269,2.375.712,2.375.712l.5806-1.9139-5.7416-1.7416-1.7417,5.7416,1.9139.5806.7783-2.5654,3.6408,6.5537-6.4238,11.0117h-12.4258v2h13-.0002ZM21,16c0-2.7568-2.2432-5-5-5s-5,2.2432-5,5,2.2432,5,5,5,5-2.2432,5-5ZM19,16c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMaximoApplicationSuite.propTypes = iconPropTypes;
}
const IbmMq = /*#__PURE__*/React.forwardRef(function IbmMq({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2 c7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,23.8l-1-1.7c2.2-1.2,3.5-3.6,3.5-6.1c0-3.9-3.1-7-7-7c-0.6,0-1.2,0.1-1.8,0.2l-0.5-1.9C14.5,7.1,15.2,7,16,7 c5,0,9,4,9,9C25,19.2,23.3,22.2,20.5,23.8z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,28.4C4.9,26,2,21.2,2,16c0-1.5,0.2-2.9,0.7-4.3l1.9,0.6C4.2,13.5,4,14.7,4,16c0,4.5,2.5,8.6,6.5,10.6L9.5,28.4z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2 c0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2 c0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMq.propTypes = iconPropTypes;
}
const IbmOpenEnterpriseLanguages = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H24V14H22z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H20V14H18z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14h-2c-1.103,0-2-0.897-2-2V8c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v4C16,13.103,15.103,14,14,14z M12,8v4h2V8H12z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H8V14H6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmOpenEnterpriseLanguages.propTypes = iconPropTypes;
}
const IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m29,31h-13c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h13c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-13-6v4h13v-4h-13Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m29,21h-13c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h13c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-13-6v4h13v-4h-13Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmPlanningAnalytics = /*#__PURE__*/React.forwardRef(function IbmPlanningAnalytics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,16.4l-6,12c-.2.3-.5.6-.9.6h-13c-.6,0-1-.4-1-1s.4-1,1-1h12.4l5.5-11-5.5-11h-12.4c-.6,0-1-.4-1-1s.4-1,1-1h13c.4,0,.7.2.9.6l6,12c.1.3.1.6,0,.9h0v-.1ZM10,22c0,.6.4,1,1,1h11v-2h-11c-.6,0-1,.4-1,1ZM18,15H7c-.6,0-1,.4-1,1s.4,1,1,1h11v-2ZM22,11v-2h-11c-.6,0-1,.4-1,1s.4,1,1,1h11ZM3,15c-.6,0-1,.4-1,1s0,0,0,0h0c0,.6.4,1,1,1s1-.4,1-1,0,0,0,0h0c0-.6-.4-1-1-1ZM6,21c-.6,0-1,.4-1,1s.4,1,1,1,1-.4,1-1-.4-1-1-1ZM6,11c.6,0,1-.4,1-1s-.4-1-1-1-1,.4-1,1,.4,1,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPlanningAnalytics.propTypes = iconPropTypes;
}
const IbmPowerVs = /*#__PURE__*/React.forwardRef(function IbmPowerVs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-2,0-4-0.7-5.6-2l1.3-1.6c1.3,1,2.8,1.5,4.4,1.5c3.9,0,7-3.1,7-7c0-0.3,0-0.7-0.1-1l2-0.3C25,15.1,25,15.6,25,16 C25,21,21,25,16,25z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1,17.3C7,16.9,7,16.4,7,16c0-5,4-9,9-9c2,0,4,0.7,5.6,2l-1.3,1.6C19.1,9.5,17.6,9,16,9c-3.9,0-7,3.1-7,7 c0,0.3,0,0.7,0.1,1L7.1,17.3z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16c0-3.7,1.5-7.3,4.1-9.9l1.4,1.4C5.2,9.8,4,12.8,4,16c0,6.6,5.4,12,12,12c1.4,0,2.8-0.2,4.1-0.7 l0.7,1.9C19.3,29.7,17.6,30,16,30z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,25.9l-1.4-1.4c2.3-2.3,3.5-5.3,3.5-8.5c0-6.6-5.4-12-12-12c-1.4,0-2.8,0.2-4.1,0.7l-0.7-1.9C12.7,2.3,14.4,2,16,2 c7.7,0,14,6.3,14,14C30,19.7,28.5,23.3,25.9,25.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerVs.propTypes = iconPropTypes;
}
const IbmPowerVsPrivateCloud = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m4,16c0-3.3084,1.3457-6.3084,3.5186-8.4813l-1.4182-1.4182c-2.5335,2.5335-4.1005,6.0334-4.1005,9.8994,0,7.732,6.268,14,14,14v-2c-6.6168,0-12-5.3832-12-12Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m16,4c6.6168,0,12,5.3832,12,12h2c0-7.732-6.268-14-14-14-1.6813,0-3.2861.3116-4.7795.855l.6837,1.8803c1.2804-.4672,2.6558-.7353,4.0959-.7353Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerVsPrivateCloud.propTypes = iconPropTypes;
}
const IbmPowerWithVpc = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m9,21H3c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2Zm-6-8v6h6v-6H3Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m11.6926,29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022,2.3466,3.7827,4.1082,6.4214,4.9606l-.6147,1.9031Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m29,31h-13c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h13c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-13-6v4h13v-4h-13Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8896,21h2.1848c.6057-1.5889.9255-3.29.9255-5,0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186,1.3262.186,2,0,1.7549-.3867,3.4297-1.1104,5Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m28,7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467,1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496,1.0581l-1.8467-1.0664-1,1.7324,1.8574,1.0723c-.0942.3403-.1611.6914-.1611,1.0615s.0669.7212.1611,1.0615l-1.8574,1.0723,1,1.7324,1.8467-1.0664c.5.5088,1.1394.8721,1.8496,1.0576v2.1426h2v-2.1426c.7102-.1855,1.3496-.5488,1.8496-1.0576l1.8467,1.0664,1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615Zm-4,2c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m5.886,9.5392l-1.6846-1.0784C6.7915,4.4153,11.2021,2,16,2v2c-4.1125,0-7.8936,2.0707-10.114,5.5392Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerWithVpc.propTypes = iconPropTypes;
}
const IbmPrivatePathServices = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPrivatePathServices.propTypes = iconPropTypes;
}
const IbmProcessMining = /*#__PURE__*/React.forwardRef(function IbmProcessMining({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmProcessMining.propTypes = iconPropTypes;
}
const IbmSaasConsole = /*#__PURE__*/React.forwardRef(function IbmSaasConsole({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m8,14c2.2165,0,4.1514,1.2112,5.1903,3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395,1.6125-6.9229,4.0032l1.7326,1.0002c1.0389-1.7922,2.9738-3.0034,5.1903-3.0034Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m16,6c2.7571,0,5.2571,1.1216,7.0678,2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083,1.3457-8.4813,3.5188l1.4135,1.4133c1.8107-1.8105,4.3107-2.9321,7.0678-2.9321Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSaasConsole.propTypes = iconPropTypes;
}
const IbmSapOnPower = /*#__PURE__*/React.forwardRef(function IbmSapOnPower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m9,21H3c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2ZM3,13v6h6v-6s-6,0-6,0Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m11.6926,29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022,2.3466,3.7827,4.1082,6.4214,4.9606l-.6147,1.9031Z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m29,31h-13c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h13c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-13-6v4h13v-4s-13,0-13,0Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8896,21h2.1848c.6057-1.5889.9255-3.29.9255-5,0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186,1.3262.186,2,0,1.7549-.3867,3.4297-1.1104,5Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m25.5,12h-6.5c-.5522,0-1-.4478-1-1V4c0-.5522.4478-1,1-1h12c.3828,0,.7319.2185.8994.5629.0675.1389.1006.2884.1006.4371,0,.22-.0725.4382-.2136.6178l-5.5,7c-.1897.2413-.4795.3822-.7864.3822Zm-5.5-2h5.0139l3.9287-5h-8.9426v5Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m5.886,9.5392l-1.6846-1.0784C6.7915,4.4153,11.2021,2,16,2v2c-4.1125,0-7.8936,2.0707-10.114,5.5392Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSapOnPower.propTypes = iconPropTypes;
}
const IbmSecureInfrastructureOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m9,21H3c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2ZM3,13v6h6v-6s-6,0-6,0Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-.3618,0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247,3.1628,5.4602,5.2205,9.1899,5.5043.3047.0231.613.0349.9241.0349v2Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m23,30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.1,1Zm-3-10v4.5c0,1.2.7,2.2,1.7,2.7l1.3.6,1.3-.6c1-.5,1.7-1.6,1.7-2.7v-4.5h-6Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3025,12c.4539,1.2817.6975,2.6211.6975,4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m27,10h-3c-1.1028,0-2-.8972-2-2v-3c0-1.1028.8972-2,2-2h3c1.1028,0,2,.8972,2,2v3c0,1.1028-.8972,2-2,2Zm-3-5v3h3v-3h-3Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m20,2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976,0-9.2083,2.415-11.7983,6.4604l1.6841,1.0786c2.2209-3.4683,6.002-5.5391,10.1143-5.5391,1.3787,0,2.7188.2437,4,.6978v-2.1143Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecureInfrastructureOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmStreamsets = /*#__PURE__*/React.forwardRef(function IbmStreamsets({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,18c-1.2,0-2.2-.6-2.8-1.6l-3.8-6.4c-.7-1.2-2-2-3.5-2h-2.5v-2h2.5c2.1,0,4.1,1.1,5.2,3l3.8,6.4c.3.5.8.6,1,.6h0c.2,0,.7,0,1-.6l3.7-6.4,1.7,1-3.7,6.4c-.6,1-1.6,1.6-2.8,1.6,0,0,.2,0,.2,0ZM10.6,27l-1.2-2.2c-.6-1-.6-2.1,0-3.1l4.2-7.4c.5-.9.5-2,0-2.9s-1.5-1.4-2.5-1.4h-7.1v2h7.1c.5,0,.7.3.8.4s.2.5,0,.9l-4.2,7.4c-.9,1.6-.9,3.5,0,5.1l1.2,2.2,1.7-1ZM16.6,29l-2.9-5c-.2-.4-.2-.9,0-1.3s.6-.7,1.1-.7h7.3c2.1,0,4.1-1.2,5.2-3l1.1-2-1.7-1-1.1,2c-.7,1.3-2,2-3.4,2h-7.3c-1.2,0-2.3.6-2.9,1.7-.6,1-.6,2.3,0,3.3l2.9,5s1.7-1,1.7-1ZM30.5,21.5l.3-.5-1.7-1-.3.5c-1.3,2.2-3.6,3.5-6.1,3.5h-4.7v2h4.7c3.2,0,6.2-1.7,7.8-4.5ZM22,10l-2-3.5c-1.6-2.8-4.6-4.5-7.8-4.5h-1.1v2h1.1c2.5,0,4.8,1.3,6.1,3.5l2,3.5,1.7-1ZM6.2,27l-.2-.4c-1.3-2.2-1.3-4.9,0-7l2.1-3.6-1.7-1-2.1,3.6c-1.6,2.8-1.6,6.2,0,9l.2.4s1.7-1,1.7-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmStreamsets.propTypes = iconPropTypes;
}
const IbmTelehealth = /*#__PURE__*/React.forwardRef(function IbmTelehealth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8,0-5,2.2-5,5v5H2v-5c0-3.9,3.1-7,7-7h6c3.9,0,7,3.1,7,7v5Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.2V3c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v6c0,1.1,.9,2,2,2h8c1.1,0,2-.9,2-2v-2.2l3,2.2V3l-3,2.2Zm-2,3.8h-8V3h8v6Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,12.5c-.9,.9-2.1,1.5-3.5,1.5-2.8,0-5-2.2-5-5s2.2-5,5-5c.5,0,.9,.1,1.3,.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9,0-7,3.1-7,7s3.1,7,7,7c1.9,0,3.7-.8,5-2l-1.5-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTelehealth.propTypes = iconPropTypes;
}
const IbmTenet = /*#__PURE__*/React.forwardRef(function IbmTenet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTenet.propTypes = iconPropTypes;
}
const IbmTestAcceleratorForZ = /*#__PURE__*/React.forwardRef(function IbmTestAcceleratorForZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M8,6h-2v10h2V6ZM4,22.43v-13.43h-2v14.01c0,.36.19.68.5.86l10.5,6.13,1.01-1.73h0l-10-5.84h-.01ZM26,13h2v-4c0-.36-.19-.68-.5-.86L15.5,1.14c-.16-.09-.33-.14-.5-.14s-.35.05-.5.14l-4,2.33c-.31.18-.5.51-.5.86v8.67h2V4.91l3-1.75,11,6.42v3.43-.01ZM24.03,17.06l1.79,3.13,1.47-1.47-2.41-4.22c-.18-.32-.51-.53-.88-.5-.36,0-.7.21-.87.53l-7,13c-.17.31-.16.68.02.99.18.3.51.49.86.49h13v-2h-11.33l5.35-9.94v-.01ZM24.42,21.58l-1.41,1.41,3,3,5-5-1.41-1.41-3.59,3.59-1.59-1.59Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTestAcceleratorForZ.propTypes = iconPropTypes;
}
const IbmToolchain = /*#__PURE__*/React.forwardRef(function IbmToolchain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M25,21c-.7396,0-1.4241,.2155-2.0191,.5669l-2.0314-2.0314-1.4141,1.4141,2.0314,2.0314c-.3514,.595-.5668,1.2795-.5668,2.019,0,2.2056,1.7944,4,4,4,.3557,0,.6943-.0615,1.0228-.1492l-2.4368-2.4368,.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136,0-1.103,.897-2,2-2,.5515,0,1.0515,.2242,1.4136,.5864l.0004-.0005,2.4368,2.4368c.0875-.3284,.1491-.667,.1491-1.0227,0-2.2056-1.7944-4-4-4Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9495,12.4644l3.7645-3.7645c.3911,.1868,.8237,.3,1.2861,.3,1.6569,0,3-1.3431,3-3s-1.3431-3-3-3-3,1.3431-3,3c0,.4622,.1132,.8948,.2999,1.2859l-3.7645,3.7645,1.4141,1.4141Zm5.0505-7.4644c.5514,0,1,.4486,1,1s-.4486,1-1,1-1-.4486-1-1,.4486-1,1-1Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12c-2.2092,0-4,1.7908-4,4,0,.7405,.215,1.4254,.5657,2.0201l-5.2795,5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569,0-3,1.3431-3,3s1.3431,3,3,3,3-1.3431,3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948,.3507,1.2795,.5657,2.02,.5657,2.2091,0,4-1.7909,4-4s-1.7909-4-4-4ZM6,27c-.5514,0-1-.4486-1-1s.4486-1,1-1,1,.4486,1,1-.4486,1-1,1Zm10-9c-1.1028,0-2-.8972-2-2s.8972-2,2-2,2,.8972,2,2-.8972,2-2,2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M7,11c.7396,0,1.4241-.2155,2.0191-.5669l2.0311,2.0311,1.4141-1.4141-2.0311-2.0311c.3514-.595,.5668-1.2795,.5668-2.019,0-2.2056-1.7944-4-4-4-.3557,0-.6943,.0615-1.0228,.1492l2.4368,2.4368-.0004,.0005c.3621,.3621,.5864,.8621,.5864,1.4136,0,1.103-.897,2-2,2-.5515,0-1.0515-.2242-1.4136-.5864l-.0004,.0005-2.4368-2.4368c-.0875,.3284-.1491,.667-.1491,1.0227,0,2.2056,1.7944,4,4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmToolchain.propTypes = iconPropTypes;
}
const IbmTurbonomic = /*#__PURE__*/React.forwardRef(function IbmTurbonomic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTurbonomic.propTypes = iconPropTypes;
}
const IbmUnstructuredDataProcessor = /*#__PURE__*/React.forwardRef(function IbmUnstructuredDataProcessor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22,10c-2.2061,0-4-1.7944-4-4s1.7939-4,4-4,4,1.7944,4,4-1.7939,4-4,4ZM22,4c-1.1025,0-2,.897-2,2s.8975,2,2,2,2-.897,2-2-.8975-2-2-2Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19h-7v-7h7v7ZM16,17h3v-3h-3v3Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6182,12H3.3818L8,2.7642l4.6182,9.2358ZM6.6182,10h2.7637l-1.3818-2.7642-1.3818,2.7642Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30h-8c-1.103,0-2-.8975-2-2v-4.4648l-5.1094-3.4062c-.5576-.3721-.8906-.9941-.8906-1.6641v-4.4648h2v4.4648l5.1094,3.4062c.5576.3721.8906.9941.8906,1.6641v4.4648h8v-4.4648c0-.6699.333-1.292.8906-1.6641l5.1094-3.4062v-6.4648h2v6.4648c0,.6699-.333,1.292-.8906,1.6641l-5.1094,3.4062v4.4648c0,1.1025-.8975,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmUnstructuredDataProcessor.propTypes = iconPropTypes;
}
const IbmVpnForVpc = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m29,23v-2c0-1.6499-1.3501-3-3-3s-3,1.3501-3,3v2c-1.1001,0-2,.8999-2,2v4c0,1.1001.8999,2,2,2h6c1.1001,0,2-.8999,2-2v-4c0-1.1001-.8999-2-2-2Zm-4-2c0-.5498.45-1,1-1s1,.4502,1,1v2h-2v-2Zm4,8h-6v-4h6v4Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m7,22.14v-9.14h-2v9.14c-1.72.45-3,2-3,3.86,0,2.21,1.79,4,4,4,1.86,0,3.41-1.28,3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86Zm-1,5.86c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m30,6c0-2.21-1.79-4-4-4-1.86,0-3.41,1.28-3.86,3h-9.14v2h9.14c.37,1.4,1.46,2.49,2.86,2.86v5.14h2v-5.14c1.72-.45,3-2,3-3.86Zm-4,2c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmVpnForVpc.propTypes = iconPropTypes;
}
const IbmVsiOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m9,21H3c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2ZM3,13v6h6v-6s-6,0-6,0Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-.3618,0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247,3.1628,5.4602,5.2205,9.1899,5.5043.3047.0231.613.0349.9241.0349v2Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30h-8c-1.1028,0-2-.8972-2-2v-8c0-1.1028.8972-2,2-2h8c1.1028,0,2,.8972,2,2v8c0,1.1028-.8972,2-2,2Zm-8-10v8h8v-8h-8Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3025,12c.4539,1.2817.6975,2.6211.6975,4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m27,10h-3c-1.1028,0-2-.8972-2-2v-3c0-1.1028.8972-2,2-2h3c1.1028,0,2,.8972,2,2v3c0,1.1028-.8972,2-2,2Zm-3-5v3h3v-3h-3Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m20,2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976,0-9.2083,2.415-11.7983,6.4604l1.6841,1.0786c2.2209-3.4683,6.002-5.5391,10.1143-5.5391,1.3787,0,2.7188.2437,4,.6978v-2.1143Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmVsiOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmWaziDeploy = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m29,13h-2v-3.4257l-11-6.4166-3,1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12,7c.3071.1792.4961.5081.4961.8638v4Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m27,23l-1.4199,1.4102,1.5898,1.5898h-7.1699v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025.8972,2,2,2h7.1699l-1.5798,1.5801,1.4099,1.4199,4-4-4-4Zm-10-4c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWaziDeploy.propTypes = iconPropTypes;
}
const IbmCloud = /*#__PURE__*/React.forwardRef(function IbmCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805,13.65A9.7327,9.7327,0,0,0,6.286,17.5387,6.75,6.75,0,0,0,7,31H23a8.7465,8.7465,0,0,0,1.5805-17.35ZM23,29.5H7a5.2373,5.2373,0,0,1-.6993-10.4293,9.7265,9.7265,0,0,0,1.1036,3.7838.75.75,0,1,0,1.3213-.709A8.25,8.25,0,0,1,22.752,13.5133a8.754,8.754,0,0,0-6.315,2.95.75.75,0,1,0,1.1245.9922A7.25,7.25,0,1,1,23,29.5Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8983,10.2548a.7582.7582,0,0,0-1.0364-.2776l-3.02,1.7438A.7587.7587,0,1,0,28.6,13.035l3.02-1.7438A.7589.7589,0,0,0,31.8983,10.2548Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6764,7.87a.7583.7583,0,0,0,1.0364-.2776l1.7438-3.02a.7587.7587,0,0,0-1.314-.7588l-1.7438,3.02A.7588.7588,0,0,0,22.6764,7.87Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.0811a.759.759,0,0,0,.7588-.7588V1.8347a.7588.7588,0,1,0-1.5175,0V5.3223A.7589.7589,0,0,0,16,6.0811Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2873,7.5922a.7587.7587,0,0,0,1.314-.7588l-1.7438-3.02a.7587.7587,0,1,0-1.314.7588Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1585,11.721l-3.02-1.7438a.7587.7587,0,1,0-.7588,1.314L3.4,13.035a.7587.7587,0,1,0,.7588-1.314Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloud.propTypes = iconPropTypes;
}
const IbmCloudAppId = /*#__PURE__*/React.forwardRef(function IbmCloudAppId({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18h-6c-1.6569,0-3,1.3431-3,3v2h2v-2c0-.5523,.4477-1,1-1h6c.5523,0,1,.4477,1,1v2h2v-2c0-1.6569-1.3431-3-3-3Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17c2.2091,0,4-1.7909,4-4s-1.7909-4-4-4-4,1.7909-4,4,1.7909,4,4,4Zm0-6c1.1046,0,2,.8954,2,2s-.8954,2-2,2-2-.8954-2-2,.8954-2,2-2Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30c-7.7197,0-14-6.2804-14-14h2c0,6.6168,5.3831,12,12,12,5.2263,0,9.8162-3.3385,11.4214-8.3074l1.9033,.6147c-1.873,5.7975-7.2278,9.6926-13.3247,9.6926Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M31,16h-2c0-6.6168-5.3833-12-12-12V2c7.7197,0,14,6.2804,14,14Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M6,14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0,1.9229-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127ZM3,4v4.4678c0,1.1533,.6738,2.2178,1.7168,2.7109l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7109V4H3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudAppId.propTypes = iconPropTypes;
}
const IbmCloudBackupAndRecovery = /*#__PURE__*/React.forwardRef(function IbmCloudBackupAndRecovery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24v2h-7.5c-4.2,0-7.5-3.4-7.5-7.5,0-3.6,2.6-6.7,6.1-7.4,0,0,.6-.1.9-.1h.2l-1.6-1.6,1.4-1.4,4,4-4,4-1.4-1.4,1.6-1.6h-.2c-2.4.2-4.6,2.3-4.9,4.7-.5,3.4,2.1,6.3,5.4,6.3h7.5ZM18,24c-.5,0-1,.5-1,1s.5,1,1,1,1-.5,1-1-.5-1-1-1ZM25.9,11.1l-.1-.1c-.8-4-3.9-7.1-7.9-7.8-.6-.2-1.3-.2-1.9-.2-2.9,0-5.6,1.3-7.4,3.3l1.5,1.5c1.2-1.4,2.9-2.5,4.9-2.7,1-.1,1.9-.1,2.9.1,3.2.7,5.5,3.4,6.1,6.5l.2,1c0,.0667.0333.1.1.1l1.1.2c1.2.2,2.3.7,3.1,1.5,1.3,1.3,1.9,3.1,1.5,4.9-.5,2.5-2.5,4.3-5,4.5l1.5-1.6-1.5-1.3-4,4,4,4,1.4-1.4-1.6-1.6h0c3.5-.2,6.4-2.7,7.1-6.1.1-.5.1-.9.1-1.3,0-3.7-2.5-6.8-6.1-7.5h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBackupAndRecovery.propTypes = iconPropTypes;
}
const IbmCloudBackupServiceVpc = /*#__PURE__*/React.forwardRef(function IbmCloudBackupServiceVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M6,20h8v-2H6v-6h18V4c0-1.1045-.8955-2-2-2H6c-1.1045,0-2,.8955-2,2v22c0,1.1047.8955,2,2,2h8v-2H6v-6ZM6,4h16v6H6v-6ZM8,22.9999c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM8,15c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM8,7c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM30,17h-3.4131c2.0405,1.2246,3.4131,3.4521,3.4131,6,0,3.8599-3.1401,7-7,7s-7-3.1401-7-7c0-1.8696.728-3.6274,2.0503-4.9497l1.4141,1.4141c-.9443.9443-1.4644,2.2002-1.4644,3.5356,0,2.7568,2.2432,5,5,5s5-2.2432,5-5c0-2.0449-1.2373-3.8025-3-4.5762v3.5762h-2v-7h7v2ZM8,23c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM8,15c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM8,7c0-.5523.4477-1,1-1s1,.4477,1,1-.4477,1-1,1-1-.4477-1-1ZM30,17h-3.4131c2.0405,1.2246,3.4131,3.4521,3.4131,6,0,3.8599-3.1401,7-7,7s-7-3.1401-7-7c0-1.8696.728-3.6274,2.0503-4.9497l1.4141,1.4141c-.9443.9443-1.4644,2.2002-1.4644,3.5356,0,2.7568,2.2432,5,5,5s5-2.2432,5-5c0-2.0449-1.2373-3.8025-3-4.5762v3.5762h-2v-7h7v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBackupServiceVpc.propTypes = iconPropTypes;
}
const IbmCloudBareMetalServer = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBareMetalServer.propTypes = iconPropTypes;
}
const IbmCloudBareMetalServersVpc = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m4,24v4c0,1.1.9,2,2,2h12v-2H6v-4h12v-2H6c-1.1,0-2,.9-2,2Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m4,13v5c0,1.1.9,2,2,2h8v-2H6v-5h-2Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m28,19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m28,8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1,0,2-.9,2-2Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBareMetalServersVpc.propTypes = iconPropTypes;
}
const IbmCloudCitrixDaas = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H30V27H26z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16H23V20H19z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H30V20H26z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5 L9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudCitrixDaas.propTypes = iconPropTypes;
}
const IbmCloudCodeEngine = /*#__PURE__*/React.forwardRef(function IbmCloudCodeEngine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M22,20v7.923c0,.595-.482,1.077-1.077,1.077h-11.846c-.595,0-1.077-.482-1.077-1.077v-4.923H2v-2h6v-4.923c0-.595.482-1.077,1.077-1.077h3.923v2h-3v10h10v-7h2ZM13,8H2v2h11v-2ZM29,17c.553,0,1-.447,1-1V4c0-.552-.447-1-1-1h-12c-.553,0-1,.448-1,1v12c0,.553.447,1,1,1h12M18,5h10v10h-10V5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudCodeEngine.propTypes = iconPropTypes;
}
const IbmCloudContinuousDelivery = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,19h-5c-.8271,0-1.5-.6729-1.5-1.5v-5c0-.8271,.6729-1.5,1.5-1.5h5c.8271,0,1.5,.6729,1.5,1.5v5c0,.8271-.6729,1.5-1.5,1.5Zm-4.5-2h4v-4h-4v4Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31v-2c7.1682,0,13-5.8318,13-13,0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124,1.3855,.6213,2.8273,.6213,4.2853,0,8.271-6.729,15-15,15Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6213,20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1,7.729,7.729,1,16,1V3c-7.1682,0-13,5.8318-13,13,0,1.2648,.1812,2.5145,.5383,3.7147l-1.917,.5706Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudContinuousDelivery.propTypes = iconPropTypes;
}
const IbmCloudDatabases = /*#__PURE__*/React.forwardRef(function IbmCloudDatabases({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3h-10c-1.1,0-2,.9-2,2v22c0,1.1.9,2,2,2h10c1.1,0,2-.9,2-2V5c0-1.1-.9-2-2-2ZM11,5h10v6h-10v-6ZM11,13h10v6h-10v-6ZM11,27v-6h10v6h-10ZM2,10v16c0,1.1.9,2,2,2h3v-2h-3v-4h3v-2h-3v-4h3v-2h-3v-4h3v-2h-3c-1.1,0-2,.9-2,2ZM28,8h-3v2h3v4h-3v2h3v4h-3v2h3v4h-3v2h3c1.1,0,2-.9,2-2V10c0-1.1-.9-2-2-2ZM14,9c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM14,17c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM14,25c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDatabases.propTypes = iconPropTypes;
}
const IbmCloudDedicatedHost = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V8a2,2,0,0,0,2,2h9v4h2V10h9a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,6H6V4H26Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDedicatedHost.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Connect = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3 l4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12 z M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Connect.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Dedicated = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Dedicated.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1DedicatedHosting = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H21V17H11z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H21V13H11z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1DedicatedHosting.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Exchange = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Exchange.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2Connect = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3 c1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2Connect.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2Dedicated = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2Dedicated.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2DedicatedHosting = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H21V17H11z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H21V13H11z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2DedicatedHosting.propTypes = iconPropTypes;
}
const IbmCloudEssentialSecurityAndObservabilityServices = /*#__PURE__*/React.forwardRef(function IbmCloudEssentialSecurityAndObservabilityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5.0002v-2c7.168,0,13,5.832,13,13h-2c0-6.0654-4.9346-11-11-11ZM16,27c-6.0654,0-11-4.9344-11-10.9998h-2c0,7.168,5.832,12.9998,13,12.9998h2v-1.9999h-2ZM4.2769,12.3044l-1.8389,1.0618-1-1.7324,1.8396-1.0623c-.1661-.4971-.2776-1.0193-.2776-1.5715s.1115-1.0745.2776-1.5715l-1.8396-1.0623,1-1.7324,1.8389,1.0618c.7053-.7937,1.6443-1.3745,2.7231-1.5945v-2.1011h2v2.1011c1.0788.22,2.0178.8008,2.7231,1.5945l1.8389-1.0618,1,1.7324-1.8396,1.0623c.1661.4971.2776,1.0193.2776,1.5715s-.1115,1.0745-.2776,1.5715l1.8396,1.0623-1,1.7324-1.8389-1.0618c-.7053.7937-1.6443,1.3745-2.7231,1.5945v2.1011h-2v-2.1011c-1.0788-.22-2.0178-.8008-2.7231-1.5945ZM5,9c0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3-3,1.3457-3,3ZM30,18v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10ZM28,20h-6v4.4678c0,1.1543.6738,2.2188,1.7168,2.7119l1.2832.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudEssentialSecurityAndObservabilityServices.propTypes = iconPropTypes;
}
const IbmCloudEventNotification = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8 C10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23 c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6 c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6 c0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23 c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudEventNotification.propTypes = iconPropTypes;
}
const IbmCloudEventStreams = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6 V29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3 C11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4 C23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1 S9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudEventStreams.propTypes = iconPropTypes;
}
const IbmCloudForEducation = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543,0-3,1.3458-3,3h-2c0-2.757,2.2429-5,5-5h4c2.7571,0,5,2.243,5,5Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M15,16c-.5522,0-1,.4478-1,1v6h2v-6c0-.5522-.4478-1-1-1Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudForEducation.propTypes = iconPropTypes;
}
const IbmCloudGateKeeper = /*#__PURE__*/React.forwardRef(function IbmCloudGateKeeper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22l-5-4.96,1.59-1.57,3.41,3.38,7.41-7.35,1.59,1.58s-9,8.92-9,8.92ZM24,2H6c-1.1,0-2,.9-2,2v14.3c0,3.9,2.1,7.5,5.5,9.5l5.5,3.2,5.4-3.2c.92-.52,1.74-1.19,2.46-1.94l-1.36-1.36c-.59.61-1.26,1.14-2,1.6l-4.5,2.7-4.5-2.7c-2.8-1.6-4.5-4.6-4.5-7.8V4h18v5h2v-5c0-1.1-.9-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudGateKeeper.propTypes = iconPropTypes;
}
const IbmCloudHpc = /*#__PURE__*/React.forwardRef(function IbmCloudHpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13H28V15H26z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13H32V15H30z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17H32V19H30z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V22H15z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28H22V30H20z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28H26V30H24z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m19,26h9v-9h-9v9Zm2-7h5v5h-5v-5Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHpc.propTypes = iconPropTypes;
}
const IbmCloudHsm = /*#__PURE__*/React.forwardRef(function IbmCloudHsm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHsm.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectCryptoServices = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23 L8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3 c0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectCryptoServices.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectDbaas = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectDbaas.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectVs = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8 l-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26 l8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectVs.propTypes = iconPropTypes;
}
const IbmCloudInternetServices = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3 c0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1 s-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,26,27,26z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1 c1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5 C1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudInternetServices.propTypes = iconPropTypes;
}
const IbmCloudIpsecVpn = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M16,29c-.373,0-.7151-.2076-.8872-.5386l-2.0801-4,1.7744-.9229,1.1929,2.2939,4.3127-8.2938,1.7744,.9226-5.2,10c-.1721,.3311-.5142,.5387-.8872,.5387Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M11,15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v2.2783c-.595,.3467-1,.9849-1,1.7217v5c0,1.1025,.897,2,2,2h6c1.103,0,2-.8975,2-2v-5c0-.7368-.405-1.375-1-1.7217Zm-4-4.2783c1.103,0,2,.8975,2,2v2H5v-2c0-1.1025,.897-2,2-2Zm3,11H4v-5h6v5Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M29,2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045,0-2,.8955-2,2s.8955,2,2,2c.7385,0,1.3762-.4048,1.7227-1h7.6304l-4.1697,8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872,3.4614c.02-.0439,.1128-.2104,.1128-.4614,0-.5522-.4478-1-1-1Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M3,2c-.5522,0-1,.4478-1,1,0,.2509,.0929,.4177,.1128,.4614l1.8401,3.5386h2.2542l-1.5601-3H14V2H3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudIpsecVpn.propTypes = iconPropTypes;
}
const IbmCloudKeyProtect = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7 c1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudKeyProtect.propTypes = iconPropTypes;
}
const IbmCloudKubernetesService = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9 c0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9 l-4-2.4l-4,2.4V18.4z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1 c0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudKubernetesService.propTypes = iconPropTypes;
}
const IbmCloudLogging = /*#__PURE__*/React.forwardRef(function IbmCloudLogging({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1 c-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H24V4H16z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudLogging.propTypes = iconPropTypes;
}
const IbmCloudMassDataMigration = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H10c-1.1,0-2-0.9-2-2v-3h2v3h12v-3h2v3C24,29.1,23.1,30,22,30z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudMassDataMigration.propTypes = iconPropTypes;
}
const IbmCloudObservability = /*#__PURE__*/React.forwardRef(function IbmCloudObservability({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15h5v2h-5v-2ZM26,23h5v2h-5v-2ZM18,17.18l-2.59-2.59-1.41,1.41,4,4,6-6-1.41-1.41-4.59,4.59ZM18,25.18l-2.59-2.59-1.41,1.41,4,4,6-6-1.41-1.41-4.59,4.59ZM11,25h-2.5c-3.0327,0-5.5-2.4678-5.5-5.5,0-2.8779,2.25-5.2852,5.1231-5.4795l.8769-.0205.0493-.8701c.4395-4.0645,3.8579-7.1299,7.9507-7.1299,3.0596,0,5.8066,1.7031,7.169,4.4448l1.791-.8906c-1.7031-3.4258-5.1358-5.5542-8.96-5.5542-4.8477,0-8.938,3.4399-9.8218,8.124-3.5234.6294-6.1782,3.7246-6.1782,7.376,0,4.1357,3.3643,7.5,7.5,7.5h2.5v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudObservability.propTypes = iconPropTypes;
}
const IbmCloudPal = /*#__PURE__*/React.forwardRef(function IbmCloudPal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.5093,17.6895l-6-3.5498c-.1572-.0933-.333-.1396-.5093-.1396s-.3521.0464-.5093.1396l-6,3.5498c-.3042.1797-.4907.5068-.4907.8604v6.9004c0,.3535.1865.6807.4907.8604l6,3.5498c.1572.0933.333.1396.5093.1396s.3521-.0464.5093-.1396l6-3.5498c.3042-.1797.4907-.5068.4907-.8604v-6.9004c0-.3535-.1865-.6807-.4907-.8604Zm-1.5093,7.1904l-5,2.958-5-2.958v-5.7598l5-2.958,5,2.958v5.7598Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,26h-5c-4.4111,0-8-3.5889-8-8,0-3.7183,2.5986-6.9365,6.1577-7.7783.8438-4.7368,4.9497-8.2217,9.8423-8.2217,5.5137,0,10,4.4858,10,10h-2c0-4.4111-3.5889-8-8-8-4.1177,0-7.5386,3.084-7.9575,7.1743l-.0801.7822-.7793.1064c-2.9551.4033-5.1831,2.9556-5.1831,5.937,0,3.3086,2.6914,6,6,6h5v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPal.propTypes = iconPropTypes;
}
const IbmCloudPrivilegedAccessGateway = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4 H8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3 v4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4 C26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7 c-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPrivilegedAccessGateway.propTypes = iconPropTypes;
}
const IbmCloudProjects = /*#__PURE__*/React.forwardRef(function IbmCloudProjects({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m30,18h-10v6.4678c0,1.9229,1.1231,3.6973,2.8613,4.5195l2.1387,1.0127,2.1387-1.0127c1.7383-.8223,2.8613-2.5967,2.8613-4.5195v-6.4678h0Zm-5,9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0,1.1533-.6738,2.2178-1.7168,2.7109l-1.2832.6074h0Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m17,18H5c-1.1045,0-2,.8954-2,2v5c0,1.1045.8955,2,2,2h12v-2H5v-5h12v-2h0Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m27,4h-5c-1.1045,0-2,.8954-2,2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m15,4H5c-1.1045,0-2,.8954-2,2v7c0,1.1045.8955,2,2,2h10c1.1045,0,2-.8955,2-2v-7c0-1.1046-.8955-2-2-2h0ZM5,13v-7h10v7H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudProjects.propTypes = iconPropTypes;
}
const IbmCloudResiliency = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m24,24v6h6v-6h-6Zm4,4h-2v-2h2v2Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m2,30h6v-6H2v6Zm2-4h2v2h-2v-2Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m26,15h-9v-6.1631c1.4407-.4336,2.5-1.7571,2.5-3.3369,0-1.9297-1.5703-3.5-3.5-3.5s-3.5,1.5703-3.5,3.5c0,1.5798,1.0593,2.9033,2.5,3.3369v6.1631H6c-1.1025,0-2,.8972-2,2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2ZM14.5,5.5c0-.8271.6729-1.5,1.5-1.5s1.5.6729,1.5,1.5-.6729,1.5-1.5,1.5-1.5-.6729-1.5-1.5Zm2.5,22.5h-2v-2h2v2Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m26.5,9c1.9297,0,3.5-1.5703,3.5-3.5s-1.5703-3.5-3.5-3.5-3.5,1.5703-3.5,3.5,1.5703,3.5,3.5,3.5Zm0-5c.8271,0,1.5.6729,1.5,1.5s-.6729,1.5-1.5,1.5-1.5-.6729-1.5-1.5.6729-1.5,1.5-1.5Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m5.5,9c1.9297,0,3.5-1.5703,3.5-3.5s-1.5703-3.5-3.5-3.5-3.5,1.5703-3.5,3.5,1.5703,3.5,3.5,3.5Zm0-5c.8271,0,1.5.6729,1.5,1.5s-.6729,1.5-1.5,1.5-1.5-.6729-1.5-1.5.6729-1.5,1.5-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudResiliency.propTypes = iconPropTypes;
}
const IbmCloudSecretsManager = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4 l3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3 l1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6 C9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecretsManager.propTypes = iconPropTypes;
}
const IbmCloudSecurity = /*#__PURE__*/React.forwardRef(function IbmCloudSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23h-8c-2.21,0-4-1.79-4-4,0-1.85,1.28-3.46,3.08-3.89.42-2.33,2.47-4.11,4.92-4.11s4.5,1.77,4.92,4.11c1.8.43,3.08,2.04,3.08,3.89,0,2.21-1.79,4-4,4ZM18,21h8c1.1,0,2-.9,2-2s-.9-2-2-2h-1v-1c0-1.65-1.35-3-3-3s-3,1.35-3,3v1h-1c-1.1,0-2,.9-2,2s.9,2,2,2ZM24,2H6c-1.1,0-2,.9-2,2v14.3c0,3.9,2.1,7.5,5.5,9.5l5.5,3.2,5.4-3.2c.5-.29.97-.62,1.42-.98l-1.37-1.37c-.3.23-.62.45-.94.66l-4.5,2.7-4.5-2.7c-2.8-1.6-4.5-4.6-4.5-7.8V4h18v5h2v-5c0-1.1-.9-2-2-2h-.01Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurity.propTypes = iconPropTypes;
}
const IbmCloudSecurityComplianceCenter = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8 L24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityComplianceCenter.propTypes = iconPropTypes;
}
const IbmCloudSecurityComplianceCenterWorkloadProtection = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8 l-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4h-2c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2V20z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityComplianceCenterWorkloadProtection.propTypes = iconPropTypes;
}
const IbmCloudSecurityGroups = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityGroups({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M22.86,25.86c-.72.75-1.54,1.42-2.46,1.94l-5.4,3.2-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1.9-2,2-2h18c1.1,0,2,.9,2,2v5h-2v-5H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7,4.5-2.7c.73-.47,1.41-.99,2-1.6,0,0,1.36,1.36,1.36,1.36ZM28,12h-10v2h10v-2ZM28,20h-10v2h10v-2ZM30,16h-10v2h10v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityGroups.propTypes = iconPropTypes;
}
const IbmCloudSubnets = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSubnets.propTypes = iconPropTypes;
}
const IbmCloudSysdigSecure = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSysdigSecure.propTypes = iconPropTypes;
}
const IbmCloudTransitGateway = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5,7.5l-1.4-1.4,3.5-3.5c.8-.8,2.1-.8,2.8,0l3.5,3.5-1.4,1.4-3.5-3.5-3.5,3.5Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5,24.5l1.4,1.4-3.5,3.5c-.8.8-2.1.8-2.8,0l-3.5-3.5,1.4-1.4,3.5,3.5,3.5-3.5Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,12.5l1.4-1.4,3.5,3.5c.8.8.8,2.1,0,2.8l-3.5,3.5-1.4-1.4,3.5-3.5-3.5-3.5Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m7.5,19.5l-1.4,1.4-3.5-3.5c-.8-.8-.8-2.1,0-2.8l3.5-3.5,1.4,1.4-3.5,3.5,3.5,3.5Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-.2,0-.3,0-.5.1l-6.1-6.1c.8-1.2.8-2.8,0-4l6.1-6.1c.2.1.3.1.5.1,1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2c0,.2,0,.3.1.5l-6.1,6.1c-1.2-.8-2.8-.8-4,0l-6.1-6.1c.1-.2.1-.3.1-.5,0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2c.2,0,.3,0,.5-.1l6.1,6.1c-.8,1.2-.8,2.8,0,4l-6.1,6.1c-.2-.1-.3-.1-.5-.1-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c0-.2,0-.3-.1-.5l6.1-6.1c1.2.8,2.8.8,4,0l6.1,6.1c0,.2-.1.3-.1.5,0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2Zm-10-6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudTransitGateway.propTypes = iconPropTypes;
}
const IbmCloudVirtualServerClassic = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVirtualServerClassic.propTypes = iconPropTypes;
}

export { Humidity, HumidityAlt, Hurricane, HybridNetworking, HybridNetworkingAlt, IbmAiOnZ, IbmAiopsInsights, IbmApiConnect, IbmAppConnectEnterprise, IbmApplicationAndDiscoveryDeliveryIntelligence, IbmAspera, IbmBluepay, IbmCloud, IbmCloudAppId, IbmCloudBackupAndRecovery, IbmCloudBackupServiceVpc, IbmCloudBareMetalServer, IbmCloudBareMetalServersVpc, IbmCloudCitrixDaas, IbmCloudCodeEngine, IbmCloudContinuousDelivery, IbmCloudDatabases, IbmCloudDedicatedHost, IbmCloudDirectLink_1Connect, IbmCloudDirectLink_1Dedicated, IbmCloudDirectLink_1DedicatedHosting, IbmCloudDirectLink_1Exchange, IbmCloudDirectLink_2Connect, IbmCloudDirectLink_2Dedicated, IbmCloudDirectLink_2DedicatedHosting, IbmCloudEssentialSecurityAndObservabilityServices, IbmCloudEventNotification, IbmCloudEventStreams, IbmCloudForEducation, IbmCloudGateKeeper, IbmCloudHpc, IbmCloudHsm, IbmCloudHyperProtectCryptoServices, IbmCloudHyperProtectDbaas, IbmCloudHyperProtectVs, IbmCloudInternetServices, IbmCloudIpsecVpn, IbmCloudKeyProtect, IbmCloudKubernetesService, IbmCloudLogging, IbmCloudMassDataMigration, IbmCloudObservability, IbmCloudPal, IbmCloudPrivilegedAccessGateway, IbmCloudProjects, IbmCloudResiliency, IbmCloudSecretsManager, IbmCloudSecurity, IbmCloudSecurityComplianceCenter, IbmCloudSecurityComplianceCenterWorkloadProtection, IbmCloudSecurityGroups, IbmCloudSubnets, IbmCloudSysdigSecure, IbmCloudTransitGateway, IbmCloudVirtualServerClassic, IbmCloudant, IbmContentServices, IbmDataPower, IbmDataProductExchange, IbmDataReplication, IbmDataband, IbmDatastage, IbmDb2, IbmDb2Alt, IbmDb2Warehouse, IbmDeployableArchitecture, IbmDynamicRouteServer, IbmEloAutomotiveCompliance, IbmEloEngineeringInsights, IbmEloMethodComposer, IbmEloPublishing, IbmEngineeringLifecycleMgmt, IbmEngineeringRequirementsDoorsNext, IbmEngineeringSystemsDesignRhapsody, IbmEngineeringSystemsDesignRhapsodyModelManager, IbmEngineeringSystemsDesignRhapsodySn1, IbmEngineeringSystemsDesignRhapsodySn2, IbmEngineeringTestMgmt, IbmEngineeringWorkflowMgmt, IbmEventAutomation, IbmEventEndpointMgmt, IbmEventProcessing, IbmEventStreams, IbmGcm, IbmGlobalStorageArchitecture, IbmGranite, IbmIbv, IbmInstana, IbmJrs, IbmKnowledgeCatalog, IbmKnowledgeCatalogPremium, IbmKnowledgeCatalogStandard, IbmLaunchpadS4, IbmLpa, IbmLqe, IbmMachineLearningForZos, IbmMatch_360, IbmMaximoApplicationSuite, IbmMq, IbmOpenEnterpriseLanguages, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries, IbmPlanningAnalytics, IbmPowerVs, IbmPowerVsPrivateCloud, IbmPowerWithVpc, IbmPrivatePathServices, IbmProcessMining, IbmSaasConsole, IbmSapOnPower, IbmSecureInfrastructureOnVpcForRegulatedIndustries, IbmStreamsets, IbmTelehealth, IbmTenet, IbmTestAcceleratorForZ, IbmToolchain, IbmTurbonomic, IbmUnstructuredDataProcessor, IbmVpnForVpc, IbmVsiOnVpcForRegulatedIndustries, IbmWaziDeploy };
